export const blogHeaderText = {
  en: {
    subtitle: "News & Updates",
    title: "Latest Stories",
  },
  vi: {
    subtitle: "Tin Tức & Cập Nhật",
    title: "Câu Chuyện Mới Nhất",
  },
};

export const shareText = {
  en: {
    title: "Share this post",
    copy: "Copy",
    copied: "Copied!",
  },
  vi: {
    title: "Chia sẻ bài viết",
    copy: "Sao chép",
    copied: "Đã sao chép!",
  },
};

export const shareTextblog = {
  en: {
    title: "Share this page",
    copy: "Copy",
    copied: "Copied!",
  },
  vi: {
    title: "Chia sẻ bài viết",
    copy: "Sao chép",
    copied: "Đã sao chép!",
  },
};

export const blogTbcarrer = [
  {
    id: 1,

    // 🔥 NEW IMAGES
    mainImage: "https://tbcareer.s3.ap-southeast-2.amazonaws.com/vlog11.jpg",
    images: [
      "https://tbcareer.s3.ap-southeast-2.amazonaws.com/vlog11.jpg",
      "https://tbcareer.s3.ap-southeast-2.amazonaws.com/vlog12.jpg",
    ],
    date: "2026-03-29",

    en: {
      section: "Blog",
      title: "Saving Money in Tough Times – First Meetup",

      intro: [
        "Today I want to share a very special meetup ❤️",
        "This is the first offline meetup of a group of young people and families who have just arrived in Christchurch about a month ago.",
        "Everyone is still adjusting, so we got together to talk about something very practical:",
      ],

      highlight: "How to save money during rising living costs?",

      vibeTitle: "The vibe of the meetup",
      vibe: [
        "Warm and friendly atmosphere",
        "Real-life sharing – no theory, just practical survival tips 😄",
      ],

      tipsTitle: "Key takeaways",

      tips: [
        {
          title: "Save on petrol ⛽",
          items: [
            "Use the Z app to collect fuel discounts",
            "Register for a Kora membership card for extra savings",
            "Long-term savings can be significant",
          ],
        },
        {
          title: "Take advantage of free meals 🍲",
          items: [
            "Join university events",
            "Attend community or church gatherings",
            "Free food + networking opportunities",
          ],
        },
        {
          title: "Find part-time jobs 💼",
          items: [
            "Follow this group for job updates",
            "Many part-time opportunities for newcomers",
          ],
          link: "https://www.facebook.com/share/g/1LZQVtnXJa/?mibextid=wwXIfr",
        },
        {
          title: "Hunt for grocery deals 🥦🥩",
          items: [
            "Follow local veggie and meat shop pages",
            "Check weekly deals",
            "Save significantly on groceries if timed well",
          ],
        },
      ],

      reflectionTitle: "What I loved most",
      reflection: [
        "It’s not about how much money we saved",
        "It’s about not feeling alone in a new country",
        "Having a community and guidance from others 🙏",
      ],

      closing: [
        "If you’re new to New Zealand, especially Christchurch, don’t hesitate to join meetups like this",
        "One meetup can help you save thousands of dollars later 😉",
        "Follow me for more tips about living in NZ 🇳🇿✨",
      ],
    },

    vi: {
      section: "Blog",
      title: "Tiết Kiệm Chi Phí Thời Bão Giá – Offline Lần 1",

      intro: [
        "Hôm nay mình muốn chia sẻ một buổi gặp mặt rất đặc biệt ❤️",
        "Đây là offline lần đầu tiên của một nhóm các bạn trẻ và gia đình mới sang Christchurch khoảng 1 tháng.",
        "Ai cũng còn nhiều bỡ ngỡ, nên tụi mình gặp nhau để cùng chia sẻ một chủ đề rất thực tế:",
      ],

      highlight: "Làm sao để tiết kiệm chi phí trong thời bão giá?",

      vibeTitle: "Không khí buổi gặp",
      vibe: [
        "Rất ấm cúng, gần gũi",
        "Chia sẻ kinh nghiệm thật – không lý thuyết, toàn là tips sống sót 😄",
      ],

      tipsTitle: "Những kinh nghiệm hay",

      tips: [
        {
          title: "Tiết kiệm xăng ⛽",
          items: [
            "Tích điểm qua app Z",
            "Đăng ký thẻ thành viên Kora để được giảm giá",
            "Đi lâu dài sẽ tiết kiệm đáng kể",
          ],
        },
        {
          title: "Tận dụng đồ ăn miễn phí 🍲",
          items: [
            "Tham gia các sự kiện của trường đại học",
            "Các buổi sinh hoạt cộng đồng, nhà thờ",
            "Vừa ăn miễn phí vừa mở rộng mối quan hệ",
          ],
        },
        {
          title: "Tìm việc làm thêm 💼",
          items: [
            "Follow group để cập nhật job nhanh",
            "Nhiều việc part-time phù hợp cho người mới",
          ],
          link: "https://www.facebook.com/share/g/1LZQVtnXJa/?mibextid=wwXIfr",
        },
        {
          title: "Săn deal thực phẩm 🥦🥩",
          items: [
            "Follow các page tiệm rau, tiệm thịt",
            "Có deal hàng tuần",
            "Biết canh ngày sẽ tiết kiệm nhiều tiền chợ",
          ],
        },
      ],

      reflectionTitle: "Điều mình thích nhất",
      reflection: [
        "Không phải là tiết kiệm được bao nhiêu tiền",
        "Mà là cảm giác không còn một mình ở đất nước mới",
        "Có cộng đồng, có người chia sẻ và hướng dẫn 🙏",
      ],

      closing: [
        "Nếu bạn mới sang New Zealand, đặc biệt là Christchurch, hãy tham gia những buổi như thế này",
        "Một buổi gặp gỡ có thể giúp bạn tiết kiệm cả ngàn đô sau này 😉",
        "Follow mình để biết thêm nhiều tips sống tại NZ 🇳🇿✨",
      ],
    },
  },
  {
    id: 2,

    mainImage: "/blog/robert.jpg",
    images: ["/blog/robert.jpg", "/blog/chi van.jpg"],
    date: "2026-04-01",
    link: "https://cdanz.org.nz/PersonProfile?Action=View&PersonProfile_id=638",
    imageTitle: "/images/cdanz.png",

    en: {
      section: "Blog",
      title: "A Special Milestone – Becoming a CDANZ Member",

      intro: [
        "Today is a very special day in my journey ✨",
        "I am officially a full member of the Career Development Association of New Zealand (CDANZ).",
        "This milestone means a lot to me, not just as a title but as recognition of my journey and commitment to career development.",
      ],

      highlight: "A meaningful step forward in my career development journey",

      vibeTitle: "Gratitude & Support",
      vibe: [
        "Deep gratitude to Robert for his guidance and support",
        "Thankful for mentors, friends, and community who believed in me ❤️",
      ],

      tipsTitle: "My journey so far",

      tips: [
        {
          title: "From uncertainty",
          items: [
            "Once unsure about what career path to follow",
            "Explored different industries before finding clarity",
          ],
        },
        {
          title: "Building experience",
          items: [
            "Worked across different roles and industries",
            "Gained valuable real-world insights",
          ],
        },
        {
          title: "Finding purpose",
          items: [
            "Discovered passion in career development",
            "Committed to helping others find their direction",
          ],
        },
      ],

      reflectionTitle: "What this means to me",
      reflection: [
        "This is not the destination, but a new beginning",
        "A stronger commitment to supporting others in their career journey",
      ],

      closing: [
        "I hope to continue helping young people, returning moms, and immigrants find their path",
        "If you feel lost in your career, you are not alone",
        "I am here and ready to support you 🌿",
      ],
    },

    vi: {
      section: "Blog",
      title: "Một Cột Mốc Đặc Biệt – Trở Thành Thành Viên CDANZ",

      intro: [
        "Hôm nay là một ngày rất đặc biệt trong hành trình của mình ✨",
        "Mình đã chính thức trở thành thành viên chính thức của Hiệp hội Career Development Association of New Zealand (CDANZ).",
        "Đây không chỉ là một danh hiệu mà còn là sự công nhận cho hành trình và nỗ lực của mình với nghề tư vấn hướng nghiệp.",
      ],

      highlight: "Một bước tiến ý nghĩa trong hành trình hướng nghiệp của mình",

      vibeTitle: "Sự biết ơn",
      vibe: [
        "Biết ơn anh Robert đã hỗ trợ và đồng hành",
        "Biết ơn những người đã tin tưởng và ủng hộ mình ❤️",
      ],

      tipsTitle: "Hành trình của mình",

      tips: [
        {
          title: "Từ sự mơ hồ",
          items: [
            "Từng không biết mình phù hợp với điều gì",
            "Trải qua nhiều ngành nghề để tìm ra hướng đi",
          ],
        },
        {
          title: "Tích lũy kinh nghiệm",
          items: [
            "Làm việc trong nhiều lĩnh vực khác nhau",
            "Hiểu rõ hơn về thực tế nghề nghiệp",
          ],
        },
        {
          title: "Tìm thấy định hướng",
          items: [
            "Nhận ra đam mê với hướng nghiệp",
            "Muốn giúp người khác tìm được con đường phù hợp",
          ],
        },
      ],

      reflectionTitle: "Ý nghĩa của cột mốc này",
      reflection: [
        "Đây không phải là đích đến mà là một khởi đầu mới",
        "Là cam kết mạnh mẽ hơn trong việc hỗ trợ người khác",
      ],

      closing: [
        "Mình mong muốn tiếp tục giúp các bạn trẻ, mẹ quay lại làm việc và người nhập cư tìm hướng đi",
        "Nếu bạn đang cảm thấy mơ hồ, bạn không hề đơn độc",
        "Mình luôn sẵn sàng đồng hành cùng bạn 🌿",
      ],
    },
  },
  {
    id: 3,

    mainImage: "/blog/3/blog 3.1.jpg",

    images: [
      "/blog/3/blog 3.1.jpg",
      "/blog/3/blog 3.2.jpg",
      "/blog/3/blog 3.3.jpg",
      "/blog/3/blog 3.4.jpg",
      "/blog/3/blog 3.5.jpg",
    ],

    date: "2026-04-11",

    vi: {
      section: "Blog",

      title: "Buổi Học Nấu Ăn Chay Đầu Tiên Của Cộng Đồng",

      intro: [
        "Hôm nay là buổi học nấu ăn chay đầu tiên của cộng đồng ❤️",
        "Một buổi gặp gỡ rất đặc biệt khi mọi người cùng nhau học nấu ăn và chia sẻ những khoảnh khắc ý nghĩa.",
        "Món ăn hôm nay là một món rất quen thuộc nhưng lại được biến tấu theo cách rất thanh đạm:",
      ],

      highlight:
        "Bún Huế chay – ngon, nhẹ nhàng và phù hợp cho tất cả mọi người",

      vibeTitle: "Không khí buổi học",
      vibe: [
        "Ấm cúng và gần gũi như một gia đình",
        "Mọi người cùng nhau chuẩn bị, nấu ăn và thưởng thức",
        "Không có khoảng cách – chỉ có sự kết nối ❤️",
      ],

      tipsTitle: "Điều đặc biệt của buổi học",

      tips: [
        {
          title: "Nguyên liệu đơn giản 🌱",
          items: [
            "Chỉ sử dụng rau củ tự nhiên",
            "Không cần nguyên liệu cầu kỳ",
            "Ai cũng có thể dễ dàng thực hiện tại nhà",
          ],
        },
        {
          title: "Hương vị thanh đạm 🍜",
          items: [
            "Nước dùng nhẹ nhưng vẫn đậm đà",
            "Phù hợp cho mọi độ tuổi",
            "Tốt cho sức khỏe và dễ ăn",
          ],
        },
        {
          title: "Sự hướng dẫn tận tâm 👩‍🍳",
          items: [
            "Được chị Tuyên hướng dẫn chi tiết từng bước",
            "Chia sẻ kinh nghiệm nấu ăn thực tế",
            "Tạo cảm giác thoải mái cho người mới",
          ],
        },
        {
          title: "Cộng đồng đa dạng 🤝",
          items: [
            "Thành viên từ Bắc – Trung – Nam",
            "Độ tuổi từ 17 đến 47",
            "Mọi người cùng kết nối qua ẩm thực",
          ],
        },
      ],

      reflectionTitle: "Điều ý nghĩa nhất",
      reflection: [
        "Không chỉ là học nấu ăn",
        "Mà là cùng nhau tạo nên một không gian kết nối",
        "Một nơi mọi người có thể gặp gỡ, chia sẻ và cảm thấy thuộc về",
      ],

      closing: [
        "Hy vọng chúng ta sẽ tiếp tục gặp lại nhau trong những buổi học tiếp theo ✨",
        "Cảm ơn tất cả mọi người đã tham gia và tạo nên một buổi học thật đáng nhớ ❤️",
        "Hẹn gặp lại ở những hoạt động tiếp theo của cộng đồng!",
      ],
    },

    en: {
      section: "Blog",

      title: "Our First Vegetarian Cooking Class Together",

      intro: [
        "Today marks our very first community vegetarian cooking class ❤️",
        "It was a special gathering where everyone came together to cook, learn, and connect.",
        "The dish we learned today was simple yet meaningful:",
      ],

      highlight:
        "Vegetarian Hue noodle soup – light, healthy, and delicious for everyone",

      vibeTitle: "The atmosphere",
      vibe: [
        "Warm and welcoming like a family",
        "Everyone cooking and sharing together",
        "A space full of connection and positivity ❤️",
      ],

      tipsTitle: "What made it special",

      tips: [
        {
          title: "Simple ingredients 🌱",
          items: [
            "Made entirely from vegetables",
            "Easy to find ingredients",
            "Anyone can cook this at home",
          ],
        },
        {
          title: "Light & healthy taste 🍜",
          items: [
            "Gentle yet flavorful broth",
            "Suitable for all ages",
            "Healthy and easy to enjoy",
          ],
        },
        {
          title: "Guidance from Ms. Tuyen 👩‍🍳",
          items: [
            "Step-by-step instructions",
            "Real-life cooking tips",
            "Very beginner-friendly",
          ],
        },
        {
          title: "Diverse community 🤝",
          items: [
            "People from all regions of Vietnam",
            "Ages from 17 to 47",
            "Connected through food and culture",
          ],
        },
      ],

      reflectionTitle: "What matters most",
      reflection: [
        "It’s not just about cooking",
        "It’s about building connections",
        "A place where people feel they belong",
      ],

      closing: [
        "Looking forward to seeing everyone again in the next session ✨",
        "Thank you all for making this such a memorable experience ❤️",
        "See you at our next community event!",
      ],
    },
  },
  {
    id: 4,

    mainImage: "/blog/4/blog41.jpg",

    images: [
      "/blog/4/blog41.jpg",
      "/blog/4/blog42.jpg",
      "/blog/4/blog43.jpg",
      "/blog/4/blog44.jpg",
      "/blog/4/blog45.jpg",
    ],

    date: "2026-04-13",

    vi: {
      section: "Blog",

      title:
        "Gặp Gỡ Đại Diện AU Hannah – Kết Nối Thị Trường Du Học Việt Nam & New Zealand",

      intro: [
        "Hôm nay có dịp gặp gỡ anh Allan Anh Mai – đại diện của AU Hannah HCM trong chuyến công tác tại New Zealand.",
        "Cuộc gặp diễn ra ngay tại trung tâm thành phố Christchurch, giữa mùa thu – khi những hàng cây chuyển sắc đỏ lãng mạn, tạo nên một khung cảnh rất đẹp và đáng nhớ.",
        "Đây là một buổi trao đổi rất giá trị xoay quanh thị trường du học Việt Nam và hành trình của các bạn học sinh, sinh viên khi bước ra thế giới.",
        "Những chia sẻ thực tế đã mang lại nhiều góc nhìn sâu sắc về nhu cầu và xu hướng du học hiện nay.",
      ],

      highlight:
        "Góc nhìn thực tế về du học sinh Việt Nam tại New Zealand và cơ hội định hướng nghề nghiệp",

      vibeTitle: "Nội dung trao đổi",
      vibe: [
        "Thị trường du học tại Việt Nam và nhu cầu của học sinh cấp 3, đại học",
        "Xu hướng lựa chọn quốc gia, ngành học và lộ trình phát triển",
        "Những câu chuyện thực tế của du học sinh tại New Zealand",
      ],

      tipsTitle: "Những điểm nổi bật",

      tips: [
        {
          title: "Thị trường du học Việt Nam 🎓",
          items: [
            "Nhu cầu du học ngày càng tăng",
            "Học sinh quan tâm nhiều hơn đến định hướng nghề nghiệp",
            "Phụ huynh chú trọng vào tính thực tiễn và cơ hội việc làm",
          ],
        },
        {
          title: "Trải nghiệm du học sinh tại New Zealand 🇳🇿",
          items: [
            "Môi trường sống an toàn và thân thiện",
            "Trải nghiệm homestay giúp hoà nhập nhanh hơn",
            "Cơ hội phát triển kỹ năng độc lập",
          ],
        },
        {
          title: "Khả năng thích nghi 🌏",
          items: [
            "Sinh viên Việt Nam dần tự tin hơn trong môi trường quốc tế",
            "Khả năng hoà nhập và học hỏi nhanh",
            "Xây dựng mạng lưới bạn bè đa quốc gia",
          ],
        },
        {
          title: "Cơ hội hợp tác 🤝",
          items: [
            "Kết nối tư vấn định hướng nghề nghiệp",
            "Hỗ trợ học sinh trước và sau khi du học",
            "Tạo hệ sinh thái hỗ trợ toàn diện cho du học sinh",
          ],
        },
      ],

      reflectionTitle: "Ý nghĩa buổi gặp gỡ",
      reflection: [
        "Không chỉ là trao đổi thông tin",
        "Mà còn mở ra cơ hội hợp tác lâu dài",
        "Trong một không gian mùa thu nhẹ nhàng và đầy cảm hứng",
        "Hướng đến việc hỗ trợ tốt hơn cho các bạn du học sinh Việt Nam",
      ],

      closing: [
        "Hy vọng sẽ có thêm nhiều cơ hội hợp tác trong tương lai ✨",
        "Cảm ơn anh Allan đã chia sẻ những thông tin rất giá trị",
        "Một buổi gặp gỡ thật đẹp – cả về nội dung lẫn khung cảnh ❤️",
        "Cùng nhau tạo nên những hành trình du học ý nghĩa và bền vững hơn!",
      ],
    },

    en: {
      section: "Blog",

      title:
        "Meeting with AU Hannah Representative – Connecting Vietnam & New Zealand Study Abroad Insights",

      intro: [
        "Today I had the opportunity to meet Allan Anh Mai, representative of AU Hannah HCMC, during his visit to New Zealand.",
        "Our meeting took place in the heart of Christchurch city during autumn – the most romantic season, with vibrant red leaves creating a beautiful and memorable setting.",
        "It was a meaningful discussion around the Vietnamese study abroad market and the journey of students pursuing international education.",
        "The conversation provided valuable insights into current trends and student needs.",
      ],

      highlight:
        "Real insights into Vietnamese international students in New Zealand and future career guidance opportunities",

      vibeTitle: "Discussion highlights",
      vibe: [
        "Overview of Vietnam’s study abroad market",
        "Student demand at high school and university levels",
        "Real-life experiences of Vietnamese students in New Zealand",
      ],

      tipsTitle: "Key takeaways",

      tips: [
        {
          title: "Vietnam study abroad market 🎓",
          items: [
            "Growing demand for international education",
            "Students are more focused on career pathways",
            "Parents value practical outcomes and employability",
          ],
        },
        {
          title: "Student life in New Zealand 🇳🇿",
          items: [
            "Safe and welcoming environment",
            "Homestay experiences support faster integration",
            "Strong focus on independence and personal growth",
          ],
        },
        {
          title: "Adaptability 🌏",
          items: [
            "Vietnamese students are becoming more confident globally",
            "Quick to adapt and learn",
            "Building diverse international networks",
          ],
        },
        {
          title: "Collaboration opportunities 🤝",
          items: [
            "Career guidance support for students",
            "Pre- and post-study abroad mentoring",
            "Building a supportive ecosystem for international students",
          ],
        },
      ],

      reflectionTitle: "Why it matters",
      reflection: [
        "Beyond information sharing",
        "It opens doors for meaningful collaboration",
        "Set in a calm and inspiring autumn atmosphere",
        "Aiming to better support Vietnamese students abroad",
      ],

      closing: [
        "Looking forward to future collaboration opportunities ✨",
        "Thank you Allan for the insightful sharing",
        "A beautiful meeting – both in conversation and setting ❤️",
        "Together, we can create more meaningful study abroad journeys!",
      ],
    },
  },
  {
    id: 5,

    mainImage: "/blog/5/51.jpg", // 👉 update if you have real image
    images: [
      "/blog/5/52.jpg",
      "/blog/5/53.jpg",
      "/blog/5/54.jpg",
      "/blog/5/55.jpg",
      "/blog/5/56.jpg",
      "/blog/5/57.jpg",
    ],

    date: "2026-04-20",

    vi: {
      section: "Blog",

      title: "Buổi Giao Lưu Cùng Các Bạn Tuổi Teen – Kết Nối & Thấu Hiểu",

      intro: [
        "Hôm nay là một buổi giao lưu rất đặc biệt cùng các bạn tuổi teen và các bạn trẻ ❤️",
        "Tuổi teen là giai đoạn khá nhạy cảm – khó giao tiếp với ba mẹ, khó làm quen với bạn mới.",
        "Các bạn thường sống trong thế giới riêng, đang trong hành trình khẳng định bản thân và xây dựng cá tính.",
      ],

      highlight:
        "Kết nối thông qua những hoạt động đơn giản để mở ra giao tiếp và sự thấu hiểu",

      vibeTitle: "Cách chúng mình kết nối",
      vibe: [
        "Cùng chơi game để phá băng khoảng cách 🎮",
        "Chia sẻ sở thích để tạo sự đồng cảm",
        "Tạo không gian an toàn để các bạn được là chính mình",
      ],

      tipsTitle: "Hoạt động chính",

      tips: [
        {
          title: "Chơi bowling 🎳",
          items: [
            "Không phân biệt trình độ",
            "Chơi để vui, không áp lực",
            "Tạo tiếng cười và sự thoải mái",
          ],
        },
        {
          title: "Kết nối tự nhiên 🤝",
          items: [
            "Dễ dàng làm quen bạn mới",
            "Giao tiếp qua hoạt động thay vì nói chuyện gượng ép",
            "Tăng sự tự tin khi tương tác",
          ],
        },
        {
          title: "Hiểu bản thân & người khác 💭",
          items: [
            "Hiểu thêm về suy nghĩ của các bạn cùng trang lứa",
            "Nhìn thấy sự khác biệt về cá tính",
            "Mở rộng góc nhìn ngoài gia đình",
          ],
        },
        {
          title: "Học từ ba mẹ 👨‍👩‍👧",
          items: [
            "Quan sát cách ba mẹ networking",
            "Học cách bắt chuyện với người lạ",
            "Xây dựng kỹ năng xã hội quan trọng cho tương lai",
          ],
        },
      ],

      reflectionTitle: "Ý nghĩa buổi gặp",
      reflection: [
        "Không chỉ là một buổi chơi bowling",
        "Mà là cơ hội để các bạn mở lòng và kết nối",
        "Và cũng là cách để phụ huynh đồng hành cùng con trong hành trình trưởng thành",
      ],

      closing: [
        "Hy vọng sẽ có thêm nhiều buổi như thế này trong tương lai ✨",
        "Một không gian nơi các bạn trẻ được là chính mình",
        "Và phát triển kỹ năng giao tiếp – một kỹ năng rất quan trọng trong việc học và đi làm sau này ❤️",
      ],
    },

    en: {
      section: "Blog",

      title: "Teen Meetup – Building Connection & Understanding",

      intro: [
        "Today we had a special meetup with teenagers and young people ❤️",
        "Teenage years can be challenging – it’s often hard to communicate with parents or make new friends.",
        "Many teens live in their own world, trying to define themselves and build their identity.",
      ],

      highlight:
        "Creating connection through simple activities to encourage communication and understanding",

      vibeTitle: "How we connected",
      vibe: [
        "Playing games to break the ice 🎮",
        "Sharing common interests",
        "Creating a safe space to be themselves",
      ],

      tipsTitle: "Main activities",

      tips: [
        {
          title: "Bowling together 🎳",
          items: [
            "No skill level required",
            "Play for fun, no pressure",
            "Lots of laughter and positive energy",
          ],
        },
        {
          title: "Natural connection 🤝",
          items: [
            "Easy way to meet new people",
            "Interaction through activities instead of forced conversations",
            "Building confidence in social settings",
          ],
        },
        {
          title: "Understanding self & others 💭",
          items: [
            "Learning about peers’ thoughts and feelings",
            "Seeing different personalities",
            "Expanding perspectives beyond family space",
          ],
        },
        {
          title: "Learning from parents 👨‍👩‍👧",
          items: [
            "Observing how parents network",
            "Learning how to approach strangers",
            "Developing important social skills for future careers",
          ],
        },
      ],

      reflectionTitle: "Why it matters",
      reflection: [
        "It’s more than just a bowling session",
        "It’s about opening up and connecting",
        "And helping parents support their children’s growth journey",
      ],

      closing: [
        "Looking forward to more meetups like this ✨",
        "A space where young people can truly be themselves",
        "And develop communication skills essential for future study and work ❤️",
      ],
    },
  },
  {
    id: 6,

    mainImage: "/blog/6/1.png",
    full: true,

    images: ["/blog/6/1.png"],

    date: "2026-05-19",

    vi: {
      section: "Blog",

      title: "Skill – Direction – Network: Ba thứ thực sự tạo ra sự nghiệp",

      intro: [
        "Nhiều người nghĩ thành công bắt đầu từ điểm số. Nhưng thực tế, thứ tạo ra khác biệt lâu dài lại là ba thứ khác: skill, direction, và network.",
        "Skill là thứ giúp bạn làm được việc thật. Người ta không trả tiền cho bằng cấp — họ trả cho năng lực giải quyết vấn đề thật.",
        "Direction là biết mình đang đi đâu. Chọn đúng ngành, đúng thời điểm, đúng chiến lược. Đi nhanh mà sai hướng thì chỉ tốn thời gian.",
        "Network là đòn bẩy. Cơ hội, hợp tác, thông tin tốt — phần lớn đến từ những mối quan hệ chất lượng, không phải từ internet.",
      ],

      highlight:
        "Ba thứ này đi cùng nhau, bạn không chỉ đi làm kiếm tiền — bạn đang xây con đường sự nghiệp của riêng mình.",

      vibeTitle:
        "Networking: Mình đã làm thế nào để vừa hiệu quả vừa không kiệt sức",

      vibe: [
        "Có một thời mình gặp ít nhất 1 người mới mỗi tuần.",
        "Từ năm 19 đến 24 tuổi, mình đi liên tục.",
        "Giờ thì thả lỏng hơn — khoảng 1–2 người mới mỗi tháng là đủ.",
      ],

      tipsTitle: "Những điều mình học được về networking",

      tips: [
        {
          title: "Sức mạnh của “weak ties” 🌏",
          items: [
            "Weak ties là những người bạn gặp vì có vài điểm chung, nhưng chưa đến mức gọi là bạn thân. Cùng ngành, cùng sở thích, cùng đi một event nào đó.",
            "Điều đặc biệt là: ngoài vòng tròn của bạn, họ có những vòng tròn khác mà bạn không tiếp cận được. Và thông tin, cơ hội thường lan qua chính những cầu nối này.",
            "Khi bạn đang tìm kiếm điều gì đó — càng nhiều người biết, cơ hội càng lớn. Networking chính là cách mở rộng bán kính đó.",
          ],
        },

        {
          title: "Bắt đầu từ đâu 🎓",
          items: [
            "Cái dễ và gần nhất: hội nhóm ngay trong trường bạn",
            "Những người đồng trang lứa bây giờ — sau này sẽ là network xã hội quan trọng nhất. Airbnb, Facebook đều bắt đầu từ bạn bè cùng trường mà ra.",
            "Ngoài ra: tìm event trên Facebook. Không cần gì cao siêu — chọn chủ đề bạn muốn tìm hiểu và đi thôi.",
          ],
        },

        {
          title: "Đến event rồi thì nói gì 💬",
          items: [
            "Bắt đầu đơn giản: bạn tên gì, bạn đang làm gì.",
            "Dùng cách nói chuyện kiểu 'bạch tuột' — bám vào một chủ đề chính (chủ đề của event, hoặc thông tin gì đó về người đang nói chuyện), rồi mở ra các nhánh phụ mà bạn thực sự tò mò.",
            "Không biết nói gì? Hỏi và lắng nghe. Ai cũng thích được hỏi về bản thân — đặt câu hỏi sâu chính là cách bạn tạo giá trị mà không cần 'flex' gì cả.",
          ],
        },

        {
          title: "Làm sao để người ta nhớ đến mình 🤝",
          items: [
            "Nếu đang tìm khách hàng: đừng đi event của ngành bạn — đi event mà khách hàng tiềm năng sẽ có mặt",
            "Offer một giá trị gì đó: giới thiệu một người hữu ích, một lời khuyên nhỏ, một tài liệu hay.",
            "Share thẳng điều bạn đang tìm kiếm: mentor, cộng sự, bạn bè cùng chí hướng. Người ta không giúp được nếu không biết bạn cần gì.",
          ],
        },

        {
          title: "Giữ quan hệ sau event 🤙",
          items: [
            "Kết nối qua mạng xã hội nơi bạn đăng thường xuyên — để họ còn nhớ bạn là ai.",
            "Ai hợp thì hẹn cà phê 1–1, không cần gặp lại hết mọi người.",
            "Tương tác nhỏ: comment, gửi tài liệu, giới thiệu kết nối — những thứ đó giữ quan hệ sống lâu hơn bất kỳ namecard nào.",
          ],
        },

        {
          title: "Ngoài event, còn cách nào gặp người mới? 🙋‍♀️",
          items: [
            "Nhờ người bạn đã gặp giới thiệu tiếp.",
            "Kết nối với super connector — những người hay host event, hay tập hợp người. Quan hệ của họ thường chất hơn event thông thường nhiều.",
            "Đi chơi theo sở thích và bắt chuyện người bên cạnh. Đi after party của event — không khí vui, dễ nói chuyện hơn hẳn..",
          ],
        },

        {
          title: "Đừng làm những điều này 🚫",
          items: [
            "Đừng rải namecard. Một event mà nói chuyện được với 1–2 người hợp là đã thành công rồi. Có những người mình gặp ở event rồi đi chơi tiếp cả 3–4 tiếng sau đó.",
            "Đừng đi cùng bạn rồi dính chặt vào nhau. Nếu đi cùng thì hãy tách ra. Mình thích đi event một mình — thoải mái hơn, dễ mở chuyện hơn.",
            "Đừng cố ở lại nếu không hợp vibe. Bạn mệt, năng lượng xuống — chào và về thôi. Không ai phán xét bạn đâu.",
          ],
        },
      ],

      reflectionTitle: "Điều mình nhận ra",

      reflection: [
        "Networking không phải là đi phát thật nhiều namecard.",
        "Một event chỉ cần gặp đúng 1–2 người phù hợp đã là rất thành công.",
        "Những mối quan hệ chất lượng thường bắt đầu từ những cuộc trò chuyện thật và sự chân thành.",
      ],

      closing: [
        "Sự nghiệp không chỉ được xây bằng kiến thức ✨",
        "Mà còn bằng kỹ năng, định hướng và những con người bạn gặp trên hành trình.",
        "Đôi khi chỉ một cuộc gặp đúng lúc cũng có thể mở ra một hướng đi hoàn toàn mới ❤️",
      ],
    },

    en: {
      section: "Blog",

      title:
        "Skill – Direction – Network: The Three Things That Truly Shape a Career",

      intro: [
        "Many people think success starts with grades. But in reality, the things that create long-term difference are skill, direction, and network.",
        "Skill is what allows you to do real work. People don’t pay for degrees — they pay for the ability to solve real problems.",
        "Direction means knowing where you are going. Choosing the right field, the right timing, and the right strategy. Moving fast in the wrong direction only wastes time.",
        "Network is leverage. Opportunities, partnerships, and valuable information mostly come from quality relationships, not from the internet.",
      ],

      highlight:
        "When these three grow together, you are not just working to earn money — you are building your own career path.",

      vibeTitle:
        "Networking: How I Made It Effective Without Burning Myself Out",

      vibe: [
        "There was a time when I met at least one new person every week.",
        "From age 19 to 24, I was constantly going out and attending events.",
        "Now I take a more relaxed approach — meeting 1–2 new people a month is enough.",
      ],

      tipsTitle: "What I Learned About Networking",

      tips: [
        {
          title: "The Power of Weak Ties 🌏",
          items: [
            "Weak ties are people you meet through shared interests or environments, but not close friends yet — same industry, same hobby, or attending the same event.",
            "What makes them powerful is that outside your circle, they have completely different circles you normally cannot access. Opportunities and information often travel through these bridges.",
            "When you are searching for something — the more people who know, the bigger your chances become. Networking is simply expanding that radius.",
          ],
        },

        {
          title: "Where to Start 🎓",
          items: [
            "The easiest and closest place: groups and communities within your school.",
            "The people around you now may become your most important social network later. Airbnb and Facebook both started from university friendships.",
            "You can also find events on Facebook. Nothing complicated — just choose topics you genuinely want to learn about and go.",
          ],
        },

        {
          title: "What Do You Say at Events? 💬",
          items: [
            "Start simple: your name and what you do.",
            "Use an 'octopus-style' conversation approach — hold onto one main topic (the event topic or something about the person), then naturally branch into smaller topics you are genuinely curious about.",
            "Don’t know what to say? Ask and listen. Everyone enjoys talking about themselves — asking thoughtful questions creates value without needing to show off.",
          ],
        },

        {
          title: "How to Become Memorable 🤝",
          items: [
            "If you are looking for clients: don’t attend events in your own industry — attend events where your potential clients will be.",
            "Offer some kind of value: introduce a useful connection, give a small piece of advice, or share a helpful resource.",
            "Be honest about what you are looking for: mentors, collaborators, or like-minded friends. People cannot help if they don’t know what you need.",
          ],
        },

        {
          title: "Maintaining Relationships After Events 🤙",
          items: [
            "Connect through social media where you actively post — so people remember who you are.",
            "If you genuinely connect with someone, invite them for a one-on-one coffee. You don’t need to reconnect with everyone.",
            "Small interactions — comments, sharing resources, introducing connections — keep relationships alive far longer than business cards ever do.",
          ],
        },

        {
          title: "How Else Can You Meet New People? 🙋‍♀️",
          items: [
            "Ask people you already know to introduce you to others.",
            "Connect with super connectors — people who host events and naturally bring others together. Their network quality is often stronger than normal events.",
            "Go out through hobbies and start conversations with people nearby. Attend after-parties from events — the atmosphere is usually more relaxed and easier for conversations.",
          ],
        },

        {
          title: "Don’t Do These Things 🚫",
          items: [
            "Don’t hand out business cards to everyone. If you meet 1–2 people you genuinely connect with at an event, that’s already a success. Some people I met at events ended up hanging out together for another 3–4 hours afterward.",
            "Don’t stick only with your friends if you attend together. Split up. Personally, I enjoy going to events alone — it feels more comfortable and makes conversations easier to start.",
            "Don’t force yourself to stay if the vibe feels wrong. If your energy drops or you feel tired, just say goodbye and leave. Nobody is judging you.",
          ],
        },
      ],

      reflectionTitle: "What I Realised",

      reflection: [
        "Networking is not about handing out as many business cards as possible.",
        "If you meet just 1–2 people who truly match your energy at an event, that is already successful.",
        "Meaningful relationships are usually built from genuine conversations and sincerity.",
      ],

      closing: [
        "A career is not built by knowledge alone ✨",
        "It is also built through skills, direction, and the people you meet along the way.",
        "Sometimes one meaningful conversation at the right moment can completely change your future path ❤️",
      ],
    },
  },
  {
    id: 7,

    mainImage: "/blog/7/2.png",

    full: true,

    images: [],

    date: "2026-05-20",

    vi: {
      section: "Blog",

      title:
        "Career Counsellor, Career Coach hay Career Mentor — bạn đang cần ai?",

      intro: [
        "Dạo gần đây, feed của mình tràn ngập bài viết về 'chọn ngành học', 'định hướng nghề nghiệp', 'ngành X có nên học không'... Phần lớn đến từ các trung tâm tư vấn du học. Và mình nhận ra một vấn đề thực sự: nhiều người đang tìm đến sai người, nghe nhầm giọng, rồi đưa ra quyết định quan trọng của cả cuộc đời dựa trên thông tin từ người không được đào tạo để làm điều đó.",
        "Bài này sẽ giải thích rõ ba vai trò khác nhau — và quan trọng hơn, giúp bạn biết mình đang cần ai.",
      ],

      highlight: "Ba vai trò, ba mục đích khác nhau hoàn toàn",

      vibeTitle: "Ba vai trò khác nhau như thế nào?",

      vibe: [
        "Counsellor giúp bạn hiểu bản thân. ",
        "Coach giúp bạn hành động.",
        "Mentor giúp bạn nhìn thấy con đường thực tế phía trước.",
      ],

      tipsTitle: "Sự khác nhau nằm ở đâu?",

      tips: [
        {
          title: "Career Counsellor  (tư vấn viên nghề nghiệp) 🧠",
          items: [
            " là người được đào tạo bài bản — thường có nền tảng tâm lý học, giáo dục học, hoặc tư vấn hướng nghiệp chuyên sâu.",
            "Họ dùng các công cụ đánh giá (trắc nghiệm Holland, Strong Interest Inventory, MBTI...) để giúp bạn hiểu bản thân: năng lực, giá trị sống, kiểu tư duy.",
            " Vai trò của họ là 'chẩn đoán' — như bác sĩ đánh giá tình trạng của bạn trước khi kê đơn. Bạn cần họ nhất khi đang ở trạng thái mù mờ, chưa biết mình muốn gì hay hợp với gì.",
            "Bạn cần Counsellor nhất khi đang mông lung, chưa biết mình phù hợp với điều gì.",
          ],
        },

        {
          title: "Career Coach (huấn luyện viên sự nghiệp) 🎯",
          items: [
            "Coach không nhất thiết phải là chuyên gia trong một ngành cụ thể.",
            "Điểm mạnh của họ là đặt câu hỏi đúng, nhìn ra điểm nghẽn tư duy và giúp bạn tạo kế hoạch hành động.",
            "Coach không nói bạn phải làm gì — họ giúp bạn tự tìm ra câu trả lời và thực sự bắt đầu hành động.",
            "Bạn cần Coach khi đã có hướng nhưng vẫn trì hoãn, thiếu cấu trúc hoặc chưa biến ý tưởng thành hành động.",
          ],
        },

        {
          title: "Career Mentor (người dẫn đường) 🌏",
          items: [
            "Mentor là người đã đi qua con đường mà bạn muốn đi.",
            "Họ không dạy theo giáo trình — họ kể từ kinh nghiệm thực tế, từ những sai lầm, từ những ngã rẽ.",
            "Mentor thường giúp mở rộng network, giới thiệu cơ hội và cho bạn cái nhìn mà sách vở không có.",
            "Đây thường là mối quan hệ không quá chính thức nhưng đôi khi giá trị hơn bất kỳ dịch vụ trả phí nào.",
          ],
        },

        {
          title: "Vậy tư vấn viên du học thì sao? ✈️",
          items: [
            "Đây là điểm mấu chốt mà nhiều người bỏ qua.",
            "Tư vấn viên du học được đào tạo và có chuyên môn về hồ sơ, admission requirements, visa, học bổng, ranking trường — những thứ liên quan đến quá trình apply, không phải quyết định nghề nghiệp. Đây là hai việc hoàn toàn khác nhau.",
            "Nhưng đó là chuyên môn khác với career guidance.",
            "Khi họ viết bài về 'ngành X có tiềm năng không', 'học gì để dễ xin việc' hay 'xu hướng ngành Y năm 2026' — đó thường là content marketing, không phải tư vấn hướng nghiệp chuyên nghiệp. Thông tin có thể đúng về mặt tổng quan, nhưng nó không được cá nhân hóa cho bạn, và người viết không có công cụ hay đào tạo để đánh giá bạn hợp với ngành đó không.",
            "Nghe họ về chuyện chọn trường, chọn chương trình apply — hoàn toàn nên. Nghe họ về chuyện bạn nên làm nghề gì cả đời — hãy cẩn thận hơn.",
          ],
        },

        {
          title: "Cách dùng thông minh nhất 🤝",
          items: [
            "Lý tưởng nhất, ba vai trò này bổ sung cho nhau theo thứ tự:",
            "Bắt đầu với Counsellor để hiểu bản thân. ➡️ Làm việc với Coach để rõ mục tiêu và kế hoạch. ➡️ Kết nối với Mentor để hiểu thực tế ngành và mở rộng network.",

            "Nhưng không phải ai cũng cần cả ba cùng lúc. Câu hỏi quan trọng nhất bạn cần tự hỏi là: Tôi đang bị mắc kẹt ở đâu?",
            "Nếu chưa biết mình là ai và muốn gì ➡️ đó là việc của Counsellor. Nếu biết rồi nhưng không làm được ➡️ đó là việc của Coach. Nếu muốn hiểu thực tế ngành trước khi nhảy vào ➡️ đó là việc của Mentor.",
          ],
        },
      ],

      reflectionTitle: "Một cách nhớ nhanh 💡",

      reflection: [
        "Counsellor giúp bạn hiểu bản thân 🧠",
        "Coach giúp bạn hành động.  🎯",
        "Mentor giúp bạn nhìn thấy con đường. 🌏",
      ],

      closing: [
        "Counsellor giúp bạn hiểu bản thân 🧠",
        "Coach giúp bạn hành động.  🎯",
        "Mentor giúp bạn nhìn thấy con đường. 🌏",
        "Ba câu hỏi khác nhau. Ba người khác nhau.",
        "Đừng để một người cố trả lời cả ba — và càng đừng để người không thuộc ba nhóm này quyết định thay bạn.",
      ],
    },

    en: {
      section: "Blog",

      title:
        "Career Counsellor, Career Coach or Career Mentor — Who Do You Actually Need?",

      intro: [
        "Lately, my feed has been filled with posts about 'choosing a major', 'career direction', or 'should you study industry X?'... Most of them come from study abroad agencies. And I realised there is a real issue: many people are listening to the wrong voices and making important life decisions based on advice from people who were never trained to guide career decisions.",
        "This article will clearly explain the differences between these three roles — and more importantly, help you understand who you actually need.",
      ],

      highlight: "Three different roles. Three completely different purposes.",

      vibeTitle: "How are these three roles different?",

      vibe: [
        "A Counsellor helps you understand yourself.",
        "A Coach helps you take action.",
        "A Mentor helps you see the real-world path ahead.",
      ],

      tipsTitle: "What makes them different?",

      tips: [
        {
          title: "Career Counsellor 🧠",
          items: [
            "A Career Counsellor is professionally trained — often with backgrounds in psychology, education, or specialised career guidance.",
            "They use assessment tools such as Holland Codes, Strong Interest Inventory, MBTI, and other frameworks to help you understand your abilities, values, and thinking style.",
            "Their role is similar to diagnosis — like a doctor evaluating your situation before giving treatment. You need them most when you feel lost or unclear about who you are and what suits you.",
            "You need a Counsellor most when you are still unsure about your direction and strengths.",
          ],
        },

        {
          title: "Career Coach 🎯",
          items: [
            "A Coach does not necessarily need to be an expert in a specific industry.",
            "Their strength lies in asking the right questions, identifying mindset blocks, and helping you create an action plan.",
            "A Coach does not tell you what to do — they help you find your own answers and actually start taking action.",
            "You need a Coach when you already have direction but keep procrastinating, lacking structure, or struggling to turn ideas into action.",
          ],
        },

        {
          title: "Career Mentor 🌏",
          items: [
            "A Mentor is someone who has already walked the path you want to pursue.",
            "They do not teach from textbooks — they share real experiences, mistakes, and turning points from their journey.",
            "Mentors often help expand your network, introduce opportunities, and give you insights that books cannot provide.",
            "This relationship is usually informal, but sometimes more valuable than any paid service.",
          ],
        },

        {
          title: "So What About Study Abroad Consultants? ✈️",
          items: [
            "This is the key point many people overlook.",
            "Study abroad consultants are trained in applications, admission requirements, visas, scholarships, and university rankings — things related to the application process, not career decision-making. These are two completely different areas.",
            "That expertise is very different from professional career guidance.",
            "When they write about topics like 'Is industry X promising?', 'What should you study for better job opportunities?' or 'Career trends in 2026' — it is often content marketing rather than professional career counselling.",
            "The information may be generally correct, but it is not personalised for you, and the writer usually does not have the tools or training to evaluate whether that career truly fits you.",
            "Listening to them about choosing schools or application programs? Absolutely. Listening to them about what career you should pursue for the rest of your life? Be more careful.",
          ],
        },

        {
          title: "The Smartest Way to Use All Three 🤝",
          items: [
            "Ideally, these three roles complement each other in sequence:",
            "Start with a Counsellor to understand yourself ➡️ Work with a Coach to clarify goals and action plans ➡️ Connect with a Mentor to understand industry reality and expand your network.",
            "But not everyone needs all three at the same time. The most important question is: Where exactly are you stuck?",
            "If you do not know who you are or what you want ➡️ you probably need a Counsellor. If you know but cannot execute ➡️ you probably need a Coach. If you want to understand the industry reality before jumping in ➡️ you probably need a Mentor.",
          ],
        },
      ],

      reflectionTitle: "A Simple Way to Remember 💡",

      reflection: [
        "Counsellor helps you understand yourself 🧠",
        "Coach helps you take action 🎯",
        "Mentor helps you see the path ahead 🌏",
      ],

      closing: [
        "Counsellor helps you understand yourself 🧠",
        "Coach helps you take action 🎯",
        "Mentor helps you see the path ahead 🌏",
        "Three different questions. Three different people.",
        "Don’t let one person try to answer all three — and definitely don’t let someone outside these roles make those decisions for you.",
      ],
    },
  },
  {
    id: 8,

    mainImage: "/blog/blog 8/1.jpg",

    images: [
      "/blog/blog 8/1.jpg",
      "/blog/blog 8/2.jpg",
      "/blog/blog 8/3.jpg",
      "/blog/blog 8/4.jpg",
      "/blog/blog 8/5.jpg",
      "/blog/blog 8/6.jpg",
      "/blog/blog 8/7.jpg",
      "/blog/blog 8/8.jpg",
      "/blog/blog 8/9.jpg",
      "/blog/blog 8/10.jpg",
    ],

    date: "2026-05-25",

    vi: {
      section: "Blog",

      title:
        "10 năm sống ở Christchurch — và mình vẫn yêu thành phố này như ngày đầu",

      intro: [
        "2026 đánh dấu kỷ niệm 10 năm mình sống, học tập và làm việc tại Christchurch, New Zealand.",
        "Và sau 10 năm, câu trả lời của mình vẫn như cũ: mình vẫn yêu Christchurch.",
      ],

      highlight:
        "Christchurch không chỉ là nơi để sống. Đây là nơi dạy mình cách trưởng thành và sống có giá trị.",

      vibeTitle: "Một thành phố có đủ bốn mùa để yêu 🌿",

      vibe: [
        "Christchurch được gọi là Garden City — thành phố của những khu vườn và thiên nhiên.",
        "Mùa xuân, hoa anh đào nở khắp thành phố.",
        "Mùa hè có thể ăn trái cây thoải mái, trời nắng đẹp và chỉ cần chạy xe khoảng 10 phút là có thể ra biển.",
        "Mùa thu, lá vàng phủ kín những con đường tạo nên khung cảnh rất yên bình.",
        "Mùa đông có tuyết để trượt tuyết và tận hưởng không khí lạnh đặc trưng của New Zealand.",
      ],

      tipsTitle: "Điều mình học được từ hệ thống giáo dục New Zealand 🎓",

      tips: [
        {
          title: "Giá trị quan trọng hơn điểm số",
          items: [
            "Điều mình thích ở New Zealand là hệ thống giáo dục không chỉ tập trung vào điểm số.",
            "Học sinh được dạy cách sống độc lập và phát triển kỹ năng thực tế từ rất sớm.",
            "Một người trẻ ở đây cần biết lái xe, biết đi làm, biết tự nấu ăn và tự chịu trách nhiệm với cuộc sống của mình.",
          ],
        },

        {
          title: "Học để tạo ra giá trị",
          items: [
            "Sau khi tốt nghiệp, nhiều bạn trẻ không chỉ đi tìm việc — họ tự lên chiến lược để phát triển từ sở thích và kỹ năng của chính mình.",
            "Christchurch dạy mình rằng ý nghĩa của học tập không nằm ở tấm bằng.",
            "Điều quan trọng hơn là: bạn có thể tạo ra giá trị gì cho xã hội.",
          ],
        },

        {
          title: "Kỹ năng mới là thứ giúp bạn tồn tại",
          items: [
            "Khi bạn có đủ kỹ năng để tự làm độc lập và tạo ra sản phẩm của riêng mình, bạn mới thực sự có khả năng tồn tại lâu dài.",
            "Bằng cấp có thể mở cánh cửa đầu tiên, nhưng kỹ năng thực tế mới là thứ giữ bạn đứng vững.",
          ],
        },
      ],

      reflectionTitle: "Sau 10 năm nhìn lại 💭",

      reflection: [
        "Christchurch không phải là thành phố lớn nhất.",
        "Nhưng đây là nơi cho mình cảm giác cân bằng giữa công việc, cuộc sống và sự phát triển cá nhân.",
        "Một nơi đủ yên bình để sống, nhưng cũng đủ cơ hội để trưởng thành.",
      ],

      closing: [
        "10 năm ở Christchurch cho mình nhiều hơn một nơi để ở.",
        "Đó là nơi dạy mình về sự độc lập, giá trị của kỹ năng và ý nghĩa thật sự của việc học.",
        "Và có lẽ vì vậy mà sau từng ấy năm, mình vẫn yêu thành phố này như ngày đầu tiên.",
      ],
    },

    en: {
      section: "Blog",

      title:
        "10 Years in Christchurch — and I Still Love This City Like Day One",

      intro: [
        "2026 marks my 10-year journey of living, studying, and working in Christchurch, New Zealand.",
        "And after 10 years, my answer is still the same: I still love Christchurch.",
      ],

      highlight:
        "Christchurch is not just a place to live. It is a place that taught me how to grow and create value.",

      vibeTitle: "A city with four beautiful seasons 🌿",

      vibe: [
        "Christchurch is known as the Garden City — a place filled with nature and greenery.",
        "In spring, cherry blossoms bloom across the city.",
        "Summer means fresh fruit everywhere, sunny days, and beaches only a 10-minute drive away.",
        "Autumn paints the streets with golden leaves and peaceful scenery.",
        "Winter brings snow and opportunities to enjoy skiing and the unique cold atmosphere of New Zealand.",
      ],

      tipsTitle: "What I learned from New Zealand’s education system 🎓",

      tips: [
        {
          title: "Values matter more than grades",
          items: [
            "One thing I truly appreciate about New Zealand is that education is not only about academic scores.",
            "Students are taught independence and practical life skills from an early age.",
            "Young people here are expected to know how to drive, work, cook, and take responsibility for their own lives.",
          ],
        },

        {
          title: "Learning is about creating value",
          items: [
            "After graduation, many students do not simply look for jobs — they build strategies to grow and earn from their own interests and strengths.",
            "Christchurch taught me that the meaning of education is not the degree itself.",
            "What matters more is the value you can contribute to society.",
          ],
        },

        {
          title: "Skills are what help you survive",
          items: [
            "When you have enough skills to work independently and create something of your own, that is when you truly become sustainable.",
            "Degrees may open the first door, but practical skills are what keep you standing long-term.",
          ],
        },
      ],

      reflectionTitle: "Looking back after 10 years 💭",

      reflection: [
        "Christchurch may not be the biggest city.",
        "But it gives me a sense of balance between career, life, and personal growth.",
        "A place peaceful enough to live, yet full of opportunities to grow.",
      ],

      closing: [
        "Ten years in Christchurch gave me more than just a place to stay.",
        "It taught me independence, the value of practical skills, and the true meaning of education.",
        "And maybe that is why, after all these years, I still love this city like the very first day.",
      ],
    },
  },
  {
    id: 9,

    mainImage: "/blog/blog 9/1.jpg",

    images: [
      "/blog/blog 9/1.jpg",
      "/blog/blog 9/2.jpg",
      "/blog/blog 9/3.jpg",
      "/blog/blog 9/4.jpg",
      "/blog/blog 9/5.jpg",
      "/blog/blog 9/6.jpg",
    ],

    date: "2026-05-27",

    vi: {
      section: "Blog",

      title:
        "Christchurch — Thành phố hạnh phúc và đáng sống bậc nhất New Zealand",

      intro: [
        "Hôm nay mình có cơ hội gặp gỡ chị Stefi Porter (Stefanie Porter) — Regional Manager of International tại ChristchurchNZ, đại diện cho khu vực Christchurch và Canterbury.",
        "Cùng với anh Allan Anh Mai từ Ahhana Education, tụi mình đã có buổi trò chuyện rất thú vị về Christchurch, giáo dục quốc tế và cuộc sống tại New Zealand.",
      ],

      highlight:
        "Christchurch không chỉ là nơi để học hay làm việc — đây là nơi để trải nghiệm cuộc sống một cách cân bằng và hạnh phúc hơn.",

      vibeTitle: "Vì sao Christchurch được nhiều người yêu thích 🌿",

      vibe: [
        "Theo chia sẻ từ chị Stefi, chi phí sống tại Christchurch dễ chịu hơn nhiều thành phố lớn khác.",
        "Nếu Christchurch được xem ở mức 100 thì Auckland khoảng 117, Melbourne khoảng 137 và Sydney khoảng 155.",
        "Điều đó khiến Christchurch trở thành lựa chọn rất đáng cân nhắc cho sinh viên quốc tế và người muốn xây dựng cuộc sống lâu dài.",
        "Đây là thành phố vừa đủ yên bình để tận hưởng cuộc sống, nhưng cũng đủ cơ hội để phát triển sự nghiệp và bản thân.",
      ],

      tipsTitle: "Một thành phố dành cho trải nghiệm sống ✨",

      tips: [
        {
          title: "Môi trường sống đa văn hoá",
          items: [
            "Khoảng 28% dân số tại Christchurch là người sinh ra ngoài New Zealand đến sinh sống và làm việc.",
            "Điều đó tạo nên một cộng đồng đa văn hoá, thân thiện và dễ kết nối.",
            "Nhiều du học sinh và người nhập cư chọn Christchurch vì cảm giác dễ hoà nhập và cân bằng hơn các thành phố quá đông đúc.",
          ],
        },

        {
          title: "Thiên nhiên và chất lượng cuộc sống",
          items: [
            "Christchurch có hơn 2000 giờ nắng mỗi năm.",
            "Có hơn 700 công viên và rất nhiều không gian xanh trong thành phố.",
            "Chỉ cần lái xe một khoảng ngắn là có thể đi biển, leo núi hoặc khám phá thiên nhiên.",
            "Đặc biệt khu vực Canterbury có tới 14 ski areas dành cho những ai yêu thích mùa đông và trượt tuyết.",
          ],
        },

        {
          title: "Thành phố của sự hạnh phúc",
          items: [
            "Christchurch thường được gọi là một trong những thành phố hạnh phúc nhất New Zealand.",
            "Không chỉ vì cảnh đẹp, mà còn bởi nhịp sống cân bằng, cộng đồng thân thiện và cảm giác bình yên mà nơi này mang lại.",
            "Đây là nơi nhiều người đến để học tập, phát triển và thật sự tận hưởng cuộc sống.",
          ],
        },
      ],

      reflectionTitle: "Một buổi gặp gỡ đầy cảm hứng 💭",

      reflection: [
        "Buổi trò chuyện giúp mình hiểu thêm rất nhiều góc nhìn về Christchurch và cộng đồng quốc tế tại đây.",
        "Đôi khi một thành phố đáng sống không phải là nơi lớn nhất hay sôi động nhất.",
        "Mà là nơi khiến bạn cảm thấy được phát triển, kết nối và sống đúng với giá trị của mình.",
      ],

      closing: [
        "Cảm ơn chị Stefi Porter và anh Allan Anh Mai vì buổi chia sẻ đầy giá trị.",
        "Christchurch tiếp tục là một thành phố khiến mình thêm yêu New Zealand hơn mỗi ngày.",
        "Một nơi không chỉ để sống — mà còn để trải nghiệm, trưởng thành và hạnh phúc.",
      ],
    },

    en: {
      section: "Blog",

      title:
        "Christchurch — One of the Happiest and Most Livable Cities in New Zealand",

      intro: [
        "Today I had the opportunity to meet Stefi Porter (Stefanie Porter), Regional Manager of International at ChristchurchNZ, representing the Christchurch and Canterbury region.",
        "Together with Allan Anh Mai from Ahhana Education, we had a meaningful conversation about Christchurch, international education, and life in New Zealand.",
      ],

      highlight:
        "Christchurch is not just a place to study or work — it is a place to truly experience a balanced and fulfilling life.",

      vibeTitle: "Why people love Christchurch 🌿",

      vibe: [
        "According to Stefi, Christchurch has a much lower living cost compared to many larger cities.",
        "If Christchurch is considered 100, then Auckland is around 117, Melbourne 137, and Sydney 155.",
        "This makes Christchurch an attractive option for international students and people looking to build a long-term life in New Zealand.",
        "It is a city peaceful enough to enjoy life, yet full of opportunities for personal and career growth.",
      ],

      tipsTitle: "A city built for lifestyle and experiences ✨",

      tips: [
        {
          title: "A multicultural community",
          items: [
            "Around 28% of Christchurch residents were born outside New Zealand.",
            "This creates a diverse, welcoming, and internationally connected community.",
            "Many international students and migrants choose Christchurch because it feels easier to settle into and build a balanced lifestyle.",
          ],
        },

        {
          title: "Nature and quality of life",
          items: [
            "Christchurch enjoys over 2000 hours of sunshine every year.",
            "The city has more than 700 parks and green spaces.",
            "Within a short drive, people can enjoy beaches, mountains, and outdoor adventures.",
            "The Canterbury region also offers 14 ski areas for those who love winter and snow sports.",
          ],
        },

        {
          title: "A truly happy city",
          items: [
            "Christchurch is often described as one of the happiest cities in New Zealand.",
            "Not only because of its beautiful scenery, but also because of its balanced lifestyle and supportive community.",
            "It is a place where people come not only to study or work, but also to truly enjoy life.",
          ],
        },
      ],

      reflectionTitle: "An inspiring conversation 💭",

      reflection: [
        "This meeting gave me deeper insights into Christchurch and its international community.",
        "Sometimes the best city is not the biggest or busiest one.",
        "It is the place where you feel connected, supported, and able to grow into the best version of yourself.",
      ],

      closing: [
        "A big thank you to Stefi Porter and Allan Anh Mai for such a valuable and inspiring conversation.",
        "Christchurch continues to make me appreciate New Zealand even more each day.",
        "A place not only to live — but to experience, grow, and find happiness.",
      ],
    },
  },
  {
    id: 10,

    mainImage: "/blog/blog 10/meeting-1200.jpg",

    images: ["/blog/blog 10/meeting.jpg"],

    date: "2026-06-21",

    vi: {
      section: "Blog",

      title:
        "Kết nối cộng đồng doanh nghiệp Châu Á tại New Zealand – Cùng xây dựng cơ hội cho người nhập cư",

      intro: [
        "Thứ Bảy vừa qua, mình có cơ hội tham dự buổi gặp mặt của cộng đồng Asians In Business (AIB) – một tổ chức phi lợi nhuận được sáng lập bởi anh Jeffrey Ling đến từ Malaysia.",
        "Đây là nơi quy tụ các doanh nhân và chuyên gia đến từ nhiều quốc gia châu Á như Hàn Quốc, Malaysia, Mông Cổ, Hồng Kông, Philippines, Trung Quốc và Việt Nam đang sinh sống và làm việc tại New Zealand.",
      ],

      highlight:
        "Khi cộng đồng cùng kết nối và chia sẻ nguồn lực, chúng ta có thể tạo ra nhiều cơ hội hơn cho người nhập cư và các doanh nghiệp nhỏ phát triển bền vững.",

      vibeTitle: "Một cộng đồng đa dạng và đầy năng lượng 🌏",

      vibe: [
        "Các thành viên trong AIB hoạt động trong nhiều lĩnh vực khác nhau như di trú, ngân hàng, bất động sản, giáo dục, công nghệ và tư vấn doanh nghiệp.",
        "Mỗi người mang đến những góc nhìn và kinh nghiệm riêng, tạo nên một môi trường học hỏi và hợp tác rất giá trị.",
        "Điều mình ấn tượng nhất là tinh thần hỗ trợ lẫn nhau giữa các doanh nghiệp trong cộng đồng.",
        "Mọi người không chỉ chia sẻ cơ hội kinh doanh mà còn cùng nhau tìm cách giúp người nhập cư hòa nhập và thành công tại New Zealand.",
      ],

      tipsTitle: "Xây dựng cầu nối cho người nhập cư 🚀",

      tips: [
        {
          title: "tbCareer – Đồng hành cùng người mới đến",
          items: [
            "Thông qua tbCareer, chúng tôi hỗ trợ định hướng nghề nghiệp cho người nhập cư và du học sinh.",
            "Cung cấp các khóa học ngắn hạn giúp phát triển kỹ năng làm việc tại New Zealand.",
            "Kết nối học viên với đúng cơ hội việc làm và đúng nhà tuyển dụng.",
          ],
        },

        {
          title: "Caljn – Công nghệ hỗ trợ doanh nghiệp nhỏ",
          items: [
            "Caljn cung cấp hệ thống đặt lịch trực tuyến cho các ngành như nail, spa, tattoo, cleaning và gardening.",
            "Giúp các doanh nghiệp tiết kiệm thời gian quản lý và nâng cao trải nghiệm khách hàng.",
            "Hỗ trợ doanh nghiệp xây dựng thương hiệu và phát triển bền vững trong môi trường số.",
          ],
        },

        {
          title: "Tạo giá trị cho cả hai phía",
          items: [
            "Người nhập cư có thêm kỹ năng và cơ hội việc làm phù hợp.",
            "Doanh nghiệp tiếp cận được nguồn nhân lực đã được đào tạo và sẵn sàng làm việc.",
            "Một hệ sinh thái kết nối giữa học tập, việc làm và kinh doanh được hình thành.",
          ],
        },
      ],

      reflectionTitle: "Sức mạnh của sự kết nối 💭",

      reflection: [
        "Buổi gặp mặt giúp mình nhận ra rằng thành công không chỉ đến từ nỗ lực cá nhân.",
        "Khi những người có cùng tầm nhìn cùng nhau hợp tác, chúng ta có thể tạo ra tác động lớn hơn cho cộng đồng.",
        "Đó cũng là lý do mình tin rằng công nghệ, giáo dục và mạng lưới kết nối sẽ đóng vai trò quan trọng trong tương lai của người nhập cư tại New Zealand.",
      ],

      closing: [
        "Cảm ơn anh Jeffrey Ling và cộng đồng Asians In Business đã tạo nên một không gian kết nối ý nghĩa.",
        "Mình rất mong được tiếp tục đồng hành cùng các doanh nghiệp và cộng đồng người nhập cư trong thời gian tới.",
        "Cùng nhau, chúng ta có thể xây dựng nhiều cơ hội hơn cho thế hệ doanh nhân và người lao động mới tại New Zealand.",
      ],
    },

    en: {
      section: "Blog",

      title:
        "Building Opportunities Through the Asians In Business Community in New Zealand",

      intro: [
        "Last Saturday, I had the opportunity to attend a gathering of the Asians In Business (AIB) community, a non-profit organisation founded by Jeffrey Ling from Malaysia.",
        "The event brought together business owners and professionals from diverse Asian backgrounds, including Korea, Malaysia, Mongolia, Hong Kong, the Philippines, China, Vietnam, and many others living and working in New Zealand.",
      ],

      highlight:
        "When communities connect and share knowledge, they create more opportunities for migrants, entrepreneurs, and local businesses to succeed together.",

      vibeTitle: "A diverse and inspiring business community 🌏",

      vibe: [
        "Members of AIB work across a wide range of industries, including immigration, banking, real estate, education, technology, and business consulting.",
        "The diversity of backgrounds and expertise creates a valuable environment for learning and collaboration.",
        "What impressed me most was the willingness of members to support one another.",
        "The focus goes beyond business growth—it is about helping migrants build successful lives and careers in New Zealand.",
      ],

      tipsTitle: "Creating a bridge for migrants and businesses 🚀",

      tips: [
        {
          title: "tbCareer – Supporting migrant success",
          items: [
            "Through tbCareer, we provide career guidance for migrants and international students.",
            "We develop short training programmes to help people understand New Zealand workplaces and build job-ready skills.",
            "Our goal is to connect the right people with the right opportunities.",
          ],
        },

        {
          title: "Caljn – Technology for small businesses",
          items: [
            "Caljn provides online booking solutions for industries such as nail salons, spas, tattoo studios, cleaning services, and gardening businesses.",
            "The platform helps businesses streamline operations and improve customer experience.",
            "It enables small business owners to focus on growth while technology handles routine administration.",
          ],
        },

        {
          title: "A win-win ecosystem",
          items: [
            "Migrants gain practical skills and better employment opportunities.",
            "Businesses gain access to trained and motivated talent.",
            "Together, we create a stronger ecosystem connecting education, employment, and entrepreneurship.",
          ],
        },
      ],

      reflectionTitle: "The power of connection 💭",

      reflection: [
        "This event reminded me that success is rarely achieved alone.",
        "When people with shared values and complementary skills collaborate, they can create a much greater impact.",
        "That is why I believe technology, education, and community networks will play an increasingly important role in supporting migrants and businesses across New Zealand.",
      ],

      closing: [
        "Thank you to Jeffrey Ling and the Asians In Business community for creating such a meaningful networking platform.",
        "I look forward to continuing to collaborate with business leaders and migrant communities in the future.",
        "Together, we can create more opportunities for the next generation of migrants, professionals, and entrepreneurs in New Zealand.",
      ],
    },
  },
  {
    id: 11,

    mainImage: "/blog/blog 11/meeting2206.jpg",

    images: ["/blog/blog 11/meeting2206.jpg"],

    date: "2026-06-22",

    vi: {
      section: "Blog",

      title: "Người nhập cư thành công ở New Zealand đã làm gì khác?",

      intro: [
        "Sau khi tham dự buổi gặp mặt của cộng đồng Asians In Business (AIB), điều khiến mình ấn tượng nhất không phải là những chức danh hay thành tựu của các thành viên, mà là hành trình họ đã trải qua để xây dựng lại sự nghiệp tại New Zealand.",
        "Rất nhiều người hiện nay đang là doanh nhân, chuyên gia hoặc lãnh đạo trong các lĩnh vực khác nhau, nhưng điểm chung là họ đều từng là những người nhập cư phải bắt đầu lại từ đầu.",
      ],

      highlight:
        "Đối với nhiều người nhập cư, năng lực chuyên môn là điều kiện cần. Nhưng networking và khả năng thể hiện giá trị bản thân mới là yếu tố giúp mở ra cơ hội.",

      vibeTitle: "Một thực tế mà nhiều người nhập cư đều trải qua 🌏",

      vibe: [
        "Trong các cuộc trò chuyện, mình nhận thấy một quan điểm được nhắc đến khá nhiều.",
        "Là người châu Á tại New Zealand, chúng ta thường phải đối mặt với những bất lợi nhất định khi cạnh tranh trên thị trường lao động.",
        "Tiếng Anh có thể chưa thực sự tự nhiên như người bản địa.",
        "Kinh nghiệm làm việc trong môi trường New Zealand hoặc hiểu biết về văn hóa doanh nghiệp địa phương cũng cần thời gian để tích lũy.",
        "Điều đó không có nghĩa là chúng ta kém năng lực, mà đơn giản là chúng ta đang bắt đầu ở một vị trí khác.",
      ],

      tipsTitle: "Những bài học mình học được từ cộng đồng AIB 🚀",

      tips: [
        {
          title: "Networking không phải là lựa chọn",
          items: [
            "Hầu hết mọi người đều chủ động tham gia các sự kiện kết nối.",
            "Nhiều cơ hội việc làm đến từ các mối quan hệ hơn là từ việc nộp CV trực tuyến.",
            "Gặp gỡ đúng người đôi khi quan trọng không kém việc sở hữu một CV đẹp.",
          ],
        },

        {
          title: "Học cách giới thiệu giá trị bản thân",
          items: [
            "Nhiều người chia sẻ rằng nếu năng lực của họ là 8/10 thì họ cần thể hiện được 10/10.",
            "Không phải để khoe khoang mà để người khác hiểu được khả năng và kinh nghiệm của mình.",
            "Nếu chúng ta không kể câu chuyện của mình, rất khó để người khác nhìn thấy giá trị đó.",
          ],
        },

        {
          title: "Chủ động tạo cơ hội",
          items: [
            "Đừng chỉ chờ cơ hội xuất hiện.",
            "Hãy tham gia cộng đồng, các hội nhóm nghề nghiệp và sự kiện doanh nghiệp.",
            "Cơ hội thường đến từ những cuộc trò chuyện tưởng chừng rất bình thường.",
          ],
        },
      ],

      reflectionTitle: "Thành công không chỉ đến từ chuyên môn 💭",

      reflection: [
        "Buổi gặp mặt giúp mình nhận ra rằng rất nhiều người nhập cư thành công không phải vì họ giỏi hơn tất cả mọi người.",
        "Họ thành công vì họ dám bước ra ngoài vùng an toàn, xây dựng mạng lưới quan hệ và liên tục học hỏi.",
        "Họ hiểu rằng trong một môi trường mới, năng lực chuyên môn cần được kết hợp với khả năng giao tiếp, xây dựng niềm tin và tạo dựng hình ảnh cá nhân.",
        "Đó là một hành trình dài, nhưng hoàn toàn có thể đạt được nếu chúng ta chủ động hành động.",
      ],

      closing: [
        "Cảm ơn cộng đồng Asians In Business đã mang đến những góc nhìn rất thực tế về hành trình của người nhập cư tại New Zealand.",
        "Mỗi câu chuyện mình nghe được đều là một minh chứng rằng thành công không có con đường tắt.",
        "Kiên trì học hỏi, xây dựng kết nối và dám thể hiện giá trị bản thân có thể tạo nên những cơ hội rất lớn trong tương lai.",
      ],
    },

    en: {
      section: "Blog",

      title: "What Successful Migrants in New Zealand Do Differently",

      intro: [
        "After attending an Asians In Business (AIB) networking event, I realised that the most inspiring part was not the titles or achievements of the attendees, but the journeys they took to rebuild their careers in New Zealand.",
        "Many are now business owners, professionals, and community leaders, yet most started their New Zealand journey from scratch.",
      ],

      highlight:
        "For many migrants, professional skills are only the starting point. Networking and visibility are often what create opportunities.",

      vibeTitle: "A reality many migrants experience 🌏",

      vibe: [
        "One message came up repeatedly during conversations.",
        "As Asians in New Zealand, we sometimes face additional challenges when competing in the local job market.",
        "English may not always be our strongest advantage.",
        "Understanding local workplace culture and communication styles takes time.",
        "This does not mean we are less capable—it simply means we are starting from a different position.",
      ],

      tipsTitle: "Lessons I learned from the AIB community 🚀",

      tips: [
        {
          title: "Networking is essential",
          items: [
            "Many professionals actively attend networking events and community gatherings.",
            "A significant number of opportunities come through relationships rather than online applications.",
            "Meeting the right people can be as important as having a strong CV.",
          ],
        },

        {
          title: "Learn to communicate your value",
          items: [
            "One member shared that if their capability is 8 out of 10, they often need to present it as 10 out of 10.",
            "Not to exaggerate, but to ensure others understand their strengths and experience.",
            "If we do not tell our own story, people may never discover what we can contribute.",
          ],
        },

        {
          title: "Create opportunities proactively",
          items: [
            "Do not wait for opportunities to appear.",
            "Join professional communities and industry events.",
            "Many career opportunities begin with simple conversations.",
          ],
        },
      ],

      reflectionTitle: "Success is more than technical skills 💭",

      reflection: [
        "The event reminded me that many successful migrants are not necessarily the most talented people in the room.",
        "They succeed because they step outside their comfort zones, build meaningful relationships, and keep learning.",
        "Professional skills matter, but communication, trust, and personal branding also play a major role in career growth.",
        "It is a long journey, but one that becomes possible through consistent action and community support.",
      ],

      closing: [
        "Thank you to the Asians In Business community for sharing such honest and inspiring experiences.",
        "Every story I heard reinforced the idea that success rarely happens overnight.",
        "By continuing to learn, connect, and share our value with others, we can create more opportunities for ourselves and future generations of migrants in New Zealand.",
      ],
    },
  },
  {
    id: 12,

    mainImage: "/blog/blog12/1.png",

    seoImage: "/blog/blog12/1-1200.jpg",

    images: ["/blog/blog12/1.png", "/blog/blog12/2.png", "/blog/blog12/3.png"],

    date: "2026-06-25",

    vi: {
      section: "Blog",

      title:
        "Sức khỏe toàn diện: Ba trụ cột bạn không thể bỏ qua — Đặc biệt nếu bạn đang sống xa nhà",

      intro: [
        "Khi còn nhỏ, hầu hết chúng ta đều được dạy rằng không bệnh nghĩa là khỏe mạnh. Nhưng sau nhiều năm sống và làm việc tại New Zealand, mình nhận ra sức khỏe không chỉ là cơ thể không đau ốm.",
        "Sức khỏe thật sự là khả năng tận hưởng cuộc sống, đối mặt với thử thách và duy trì sự cân bằng trong cả thể chất, tinh thần và các mối quan hệ xung quanh. Thiếu một trong ba trụ cột này, chúng ta rất khó cảm thấy hạnh phúc lâu dài.",
      ],

      highlight:
        "Đối với người nhập cư, thành công không chỉ đến từ công việc hay thu nhập. Một cuộc sống bền vững được xây dựng trên ba nền tảng: sức khỏe thể chất, sức khỏe tinh thần và sức khỏe xã hội.",

      vibeTitle: "Ba trụ cột của một cuộc sống khỏe mạnh 🌿",

      vibe: [
        "Ba yếu tố này luôn tác động lẫn nhau.",
        "Khi cơ thể khỏe mạnh, tinh thần thường tích cực hơn.",
        "Khi tinh thần ổn định, chúng ta dễ xây dựng những mối quan hệ tốt đẹp.",
        "Và khi có một cộng đồng để kết nối, chúng ta lại có thêm động lực chăm sóc bản thân.",
        "Đó là một vòng tròn tích cực mà mỗi người đều có thể xây dựng từng ngày.",
      ],

      tipsTitle: "Ba điều mình luôn nhắc bản thân 🚀",

      tips: [
        {
          title: "1. Chăm sóc sức khỏe thể chất",
          items: [
            "Ăn uống đầy đủ dinh dưỡng thay vì chỉ ăn cho no.",
            "Dành thời gian vận động mỗi ngày, dù chỉ là đi bộ hoặc làm vườn.",
            "Ngủ đủ giấc và dành thời gian để cơ thể phục hồi.",
            "Đừng quên ánh nắng, không khí trong lành và uống đủ nước.",
          ],
        },

        {
          title: "2. Chăm sóc sức khỏe tinh thần",
          items: [
            "Chấp nhận rằng cảm xúc tiêu cực là điều bình thường.",
            "Biết nghỉ ngơi khi quá tải thay vì cố gắng chịu đựng.",
            "Học cách đặt giới hạn và yêu thương bản thân.",
            "Tìm niềm vui trong những điều rất nhỏ của cuộc sống hằng ngày.",
          ],
        },

        {
          title: "3. Đầu tư vào sức khỏe xã hội",
          items: [
            "Đừng chỉ đi làm rồi về nhà mỗi ngày.",
            "Hãy tham gia các cộng đồng, sự kiện hoặc hoạt động tình nguyện.",
            "Duy trì những cuộc trò chuyện chân thành với gia đình và bạn bè.",
            "Cho đi sự giúp đỡ và cũng sẵn sàng đón nhận sự giúp đỡ khi cần.",
          ],
        },
      ],

      reflectionTitle:
        "Điều người nhập cư thường thiếu nhất chính là sức khỏe xã hội 💭",

      reflection: [
        "Khi sống xa quê hương, điều đầu tiên chúng ta mất không phải là công việc hay ngôn ngữ, mà là mạng lưới quan hệ đã được xây dựng suốt nhiều năm.",
        "Có rất nhiều người có công việc ổn định, thu nhập tốt nhưng vẫn cảm thấy cô đơn và không thật sự thuộc về nơi mình đang sống.",
        "Điều đó không phải vì họ yếu đuối, mà bởi con người vốn được tạo ra để kết nối với những người khác.",
        "Ngay cả khi bạn là người hướng nội, bạn vẫn cần một vài mối quan hệ chất lượng để chia sẻ, lắng nghe và cảm nhận mình là một phần của cộng đồng.",
        "Theo mình, đây cũng là lý do việc tham gia các cộng đồng như Vietnamese Society, Asians In Business hay các nhóm nghề nghiệp tại New Zealand mang lại giá trị rất lớn. Không chỉ để mở rộng cơ hội nghề nghiệp, mà còn để nuôi dưỡng sức khỏe tinh thần và sức khỏe xã hội lâu dài.",
      ],

      closing: [
        "Sức khỏe không chỉ là việc đi khám khi bị bệnh.",
        "Đó là những lựa chọn nhỏ được lặp lại mỗi ngày: ăn tốt hơn, ngủ sớm hơn, vận động nhiều hơn và dành thời gian kết nối với những người xung quanh.",
        "Nếu bạn đang sống xa gia đình, hãy nhớ rằng xây dựng một cộng đồng cho riêng mình cũng là một cách chăm sóc sức khỏe.",
        "Bởi cuối cùng, một cuộc sống khỏe mạnh không chỉ là sống lâu hơn, mà là sống hạnh phúc và ý nghĩa hơn mỗi ngày.",
      ],
    },

    en: {
      section: "Blog",

      title:
        "Holistic Health: The Three Pillars You Should Never Ignore — Especially If You're Living Away From Home",

      intro: [
        "Many of us grew up believing that being healthy simply meant not being sick. After spending years living and working in New Zealand, I've come to realise that health is much more than that.",
        "True wellbeing is about having the energy to enjoy life, cope with challenges, and stay balanced physically, mentally, and socially. When one of these pillars is missing, lasting happiness becomes much harder to achieve.",
      ],

      highlight:
        "For migrants, success is not measured only by career or income. A fulfilling life is built on three equally important foundations: physical health, mental wellbeing, and social connection.",

      vibeTitle: "The three pillars of wellbeing 🌿",

      vibe: [
        "These three areas constantly influence one another.",
        "A healthier body often supports a healthier mind.",
        "A healthy mind helps us build stronger relationships.",
        "Meaningful relationships give us motivation to take better care of ourselves.",
        "Together they create a positive cycle that anyone can develop over time.",
      ],

      tipsTitle: "Three reminders I try to live by 🚀",

      tips: [
        {
          title: "1. Take care of your physical health",
          items: [
            "Eat nutritious meals instead of simply eating to feel full.",
            "Move your body every day, even if it's just walking or gardening.",
            "Prioritise quality sleep and recovery.",
            "Don't underestimate sunshine, fresh air, and staying hydrated.",
          ],
        },

        {
          title: "2. Protect your mental wellbeing",
          items: [
            "Accept that difficult emotions are part of life.",
            "Rest before burnout rather than pushing through exhaustion.",
            "Set healthy boundaries without guilt.",
            "Find joy in simple everyday moments.",
          ],
        },

        {
          title: "3. Invest in your social wellbeing",
          items: [
            "Don't let life become only work and home.",
            "Join local communities, networking events, or volunteer groups.",
            "Stay connected with family and trusted friends.",
            "Be willing to both offer and receive support.",
          ],
        },
      ],

      reflectionTitle:
        "For migrants, social wellbeing is often the missing piece 💭",

      reflection: [
        "When we move overseas, we leave behind the relationships that took years to build.",
        "Many migrants have stable jobs and comfortable lives, yet still experience loneliness and a lack of belonging.",
        "This isn't a personal weakness—it's a natural human response. We are wired for connection.",
        "Even if you're naturally introverted, meaningful relationships remain essential for emotional resilience and overall wellbeing.",
        "That's one reason why communities such as Vietnamese Society, Asians In Business, and professional networking groups play such an important role in New Zealand. They don't just create career opportunities—they also strengthen our mental and social wellbeing.",
      ],

      closing: [
        "Health is much more than visiting a doctor when something goes wrong.",
        "It's built through small daily choices: eating better, sleeping well, moving your body, and investing in meaningful relationships.",
        "If you're living far from home, remember that building your own community is also an investment in your health.",
        "Because in the end, a healthy life isn't only about living longer—it's about living with purpose, connection, and joy.",
      ],
    },
  },
  {
    id: 14,

    mainImage: "/blog/blog14/3.jpg",

    seoImage: "/blog/blog14/4.jpg",

    images: [
      "/blog/blog14/11.jpg",

      "/blog/blog14/1.jpg",
      "/blog/blog14/2.jpg",
      "/blog/blog14/3.jpg",
      "/blog/blog14/4.jpg",
      "/blog/blog14/5.jpg",
      "/blog/blog14/6.jpg",
      "/blog/blog14/7.jpg",
      "/blog/blog14/8.jpg",
      "/blog/blog14/9.jpg",
      "/blog/blog14/10.jpg",
      "/blog/blog14/11.png",
      "/blog/blog14/12.png",
    ],

    date: "2026-07-02",

    vi: {
      section: "Blog",

      title:
        "Từ Ý Tưởng Đến Startup: Hành Trình Tại EPIC Christchurch (Phần 1)",

      intro: [
        "Ngày 2/7, chúng tôi tham dự Toast Meeting tại EPIC Christchurch (Enterprise Precinct and Innovation Campus) – một trong những trung tâm đổi mới sáng tạo và hỗ trợ startup lớn của Christchurch.",
        "Đây là cơ hội để giới thiệu hệ sinh thái Caljn đến cộng đồng startup địa phương, đồng thời gặp gỡ nhiều founder đang ở những giai đoạn rất khác nhau của hành trình khởi nghiệp. Có người chỉ mới có một ý tưởng, có người đang phát triển sản phẩm đầu tiên và cũng có những startup đã bắt đầu tìm kiếm khách hàng.",
      ],

      highlight:
        "Mỗi startup thành công đều từng bắt đầu từ một ý tưởng nhỏ. Điều tạo nên sự khác biệt không phải là ý tưởng, mà là sự kiên trì biến nó thành sản phẩm thực tế.",

      vibeTitle: "Những ý tưởng mình được nghe tại EPIC 🚀",

      vibe: [
        "Một developer người Đức đang phát triển SongPanion – nền tảng tổng hợp các sự kiện âm nhạc diễn ra tại Christchurch và hướng tới toàn New Zealand.",
        "Một founder khác đang xây dựng phần mềm sử dụng AI để hỗ trợ dự đoán xu hướng thị trường chứng khoán và tiền điện tử.",
        "InterestingMe mang đến một ý tưởng rất thú vị: dùng AI để dự đoán mức độ phù hợp giữa hai người trong hệ thống, kết hợp GPS để xác định vị trí và tự động gửi thông báo khi có cơ hội kết nối.",
        "Mỗi ý tưởng đều rất khác nhau nhưng đều xuất phát từ mong muốn giải quyết một vấn đề thực tế.",
        "Điều mình thích nhất là mọi người đều rất cởi mở, sẵn sàng chia sẻ, lắng nghe và góp ý cho nhau.",
      ],

      tipsTitle: "Nhìn lại hành trình của Caljn 💡",

      tips: [
        {
          title: "Chúng tôi cũng từng bắt đầu như vậy",
          items: [
            "Khoảng 5 năm trước, Caljn cũng chỉ là một ý tưởng.",
            "Dự án đầu tiên là Mirawow.",
            "Sau đó tiếp tục phát triển thành Lokalai.",
            "Và hôm nay đã trở thành hệ sinh thái gồm Caljn, Odijn và tbCareer.",
          ],
        },

        {
          title: "Ý tưởng có thể thay đổi, nhưng năng lực thì ở lại",
          items: [
            "Trong suốt quá trình phát triển, sản phẩm thay đổi rất nhiều lần.",
            "Điều quan trọng nhất là đội ngũ vẫn tiếp tục xây dựng và học hỏi.",
            "Nhờ đó chúng tôi đã phát triển được nền tảng Full Stack Web và Mobile App hoàn chỉnh.",
            "Đó mới là tài sản lớn nhất của startup.",
          ],
        },

        {
          title: "Hành trình vẫn đang tiếp tục",
          items: [
            "Caljn phục vụ nền tảng Booking thông minh.",
            "Odijn dành cho hệ thống QR Ordering của nhà hàng.",
            "tbCareer hỗ trợ tư vấn hướng nghiệp trong thời đại AI.",
            "Hiện chúng tôi đang hướng tới thị trường New Zealand, Australia, Canada và nghiên cứu  sản phẩm cho Việt Nam và Thái Lan (có thể Mirahouse).",
          ],
        },
      ],

      reflectionTitle: "Điều mình suy nghĩ sau buổi gặp gỡ 💭",

      reflection: [
        "Ngồi nghe các founder chia sẻ, mình như nhìn thấy Caljn của 5 năm trước.",
        "Ngày đó cũng chỉ có vài ý tưởng, chưa có khách hàng và chưa biết sản phẩm cuối cùng sẽ như thế nào.",
        "Rất nhiều startup sẽ thay đổi sản phẩm trong quá trình phát triển, nhưng điều giúp họ đi tiếp chính là sự kiên trì.",
        "Ý tưởng không phải là thứ quyết định thành công. Khả năng xây dựng sản phẩm, học hỏi và không bỏ cuộc mới là điều quan trọng nhất.",
        "Đó cũng là lý do mình luôn thích tham gia những cộng đồng startup như EPIC Christchurch.",
      ],

      closing: [
        "Buổi gặp gỡ không chỉ giúp chúng tôi giới thiệu Caljn mà còn mang lại rất nhiều cảm hứng từ những founder đang bắt đầu hành trình của mình.",
        "Biết đâu vài năm nữa, một trong những ý tưởng hôm nay sẽ trở thành startup tiếp theo của New Zealand.",
        "Ở Phần 2, mình sẽ chia sẻ thêm về những bài học thú vị khi trò chuyện trực tiếp với các founder và cộng đồng startup tại EPIC.",
        {
          text: "👉 Đọc tiếp Phần 2",
          to: "/blog/15",
        },
      ],
    },

    en: {
      section: "Blog",

      title:
        "From Ideas to Startups: Our Journey at EPIC Christchurch (Part 1)",

      intro: [
        "On 2 July, we attended the Toast Meeting at EPIC Christchurch (Enterprise Precinct and Innovation Campus), one of Christchurch's leading innovation hubs for startups and entrepreneurs.",
        "It was an opportunity to introduce the Caljn ecosystem while meeting founders at many different stages of their startup journeys. Some had only an idea, others were building their first product, and some were already looking for their first customers.",
      ],

      highlight:
        "Every successful startup begins with a simple idea. The real difference isn't the idea itself—it's the persistence to keep building.",

      vibeTitle: "Startup ideas that inspired me 🚀",

      vibe: [
        "A German developer introduced SongPanion, a platform that aggregates music events across Christchurch with plans to expand throughout New Zealand.",
        "Another founder is building AI software to analyse and predict stock market and cryptocurrency trends.",
        "InterestingMe presented an innovative concept that uses AI to estimate compatibility between people, combined with GPS and automatic notifications to create real-world connections.",
        "Although every startup was different, each one aimed to solve a real problem.",
        "The atmosphere was incredibly open, with founders sharing ideas and giving each other constructive feedback.",
      ],

      tipsTitle: "Looking back at Caljn's journey 💡",

      tips: [
        {
          title: "We started exactly the same way",
          items: [
            "Around five years ago, Caljn was only an idea.",
            "Our first concept was Mirawow.",
            "That evolved into Lokalai.",
            "Today those ideas have become Caljn, Odijn and tbCareer.",
          ],
        },

        {
          title: "Ideas evolve, skills remain",
          items: [
            "Our products changed many times throughout the journey.",
            "What mattered most was continuing to build and learn.",
            "Over time we developed a complete Full Stack web and mobile platform.",
            "That capability has become our greatest asset.",
          ],
        },

        {
          title: "The journey continues",
          items: [
            "Caljn focuses on intelligent booking solutions.",
            "Odijn provides QR ordering for hospitality businesses.",
            "tbCareer supports AI-era career guidance.",
            "Today, we're focused on serving the New Zealand, Australian, and Canadian markets while also exploring new products for Vietnam and Thailand, including a potential project called MiraHouse",
          ],
        },
      ],

      reflectionTitle: "My biggest takeaway 💭",

      reflection: [
        "Listening to these founders reminded me of where Caljn began five years ago.",
        "Back then we had no customers, no revenue, and no certainty about what the final product would become.",
        "Most startups will change direction many times, but persistence is what keeps them moving forward.",
        "Success rarely comes from having the best idea. It comes from consistently building, learning, and refusing to give up.",
        "That's exactly why I enjoy attending startup communities like EPIC Christchurch.",
      ],

      closing: [
        "The event wasn't only an opportunity to introduce Caljn—it was also a reminder of why innovation communities matter.",
        "Perhaps one of today's ideas will become New Zealand's next successful startup.",
        "In Part 2, I'll share more insights from conversations with founders and what we learned from Christchurch's startup community.",
        {
          text: "👉 Continue reading Part 2",
          to: "/blog/15",
        },
      ],
    },
  },
  {
    id: 15,

    mainImage: "/blog/blog15/9.jpg",

    objectPositionDesktop: "center -150px",
    objectPositionMobile: "center 0px",

    seoImage: "/blog/blog15/seo.jpg",

    images: [
      "/blog/blog15/8.jpg",
      "/blog/blog15/9.jpg",
      "/blog/blog15/10.jpg",
      "/blog/blog15/11.jpg",
      "/blog/blog15/5.jpg",
      "/blog/blog15/6.jpg",
      "/blog/blog15/7.jpg",
      "/blog/blog15/1.jpg",
      "/blog/blog15/2.jpg",
      "/blog/blog15/3.jpg",
      "/blog/blog15/4.jpg",
      "/blog/blog15/5.jpg",
    ],

    date: "2026-07-04",

    vi: {
      section: "Blog",

      title:
        "Từ Ý Tưởng Đến Startup: Kết Nối Doanh Nhân Quốc Tế Cùng Business Beyond Borders (Phần 2)",

      intro: [
        "Sau buổi gặp gỡ tại EPIC Christchurch, chúng tôi tiếp tục tham dự Business Beyond Borders (BBB) – một cộng đồng kết nối các founder, doanh nhân và nhà đầu tư quốc tế, đặc biệt là cộng đồng doanh nghiệp Đài Loan tại New Zealand.",
        "Không chỉ là một buổi networking, đây còn là cơ hội để học hỏi từ những doanh nghiệp đã xây dựng thành công mô hình kinh doanh quốc tế, đồng thời mở rộng mối quan hệ với nhiều cộng đồng doanh nghiệp tại Christchurch.",
      ],

      highlight:
        "Khởi nghiệp không chỉ là xây dựng sản phẩm. Đó còn là hành trình xây dựng những mối quan hệ có thể tạo nên cơ hội trong tương lai.",

      vibeTitle: "Những con người truyền cảm hứng 🚀",

      vibe: [
        "Chúng tôi có dịp gặp Tiến sĩ Andy Cordier – Founder của International Culinary Studio, ngôi trường đào tạo đầu bếp trực tuyến đã hoạt động hơn 11 năm với hơn 3.000 học viên và chương trình đào tạo Level 4–5 tại New Zealand.",
        "Lấy cảm hứng từ International Culinary Studio, tbCareer International School hướng tới trở thành trường đào tạo nghề Level 4–5 tại New Zealand, nơi không chỉ đào tạo chuyên môn mà còn là cầu nối giúp người nhập cư rút ngắn khoảng cách hội nhập, phát triển sự nghiệp bền vững và tạo giá trị cho cộng đồng địa phương.",
        "Chúng tôi gặp Sam Lu – Founder của Taizi Baijiu, người đang mang văn hóa rượu truyền thống Đài Loan đến với thị trường quốc tế.",
        "Chúng tôi cũng trò chuyện với Hank Chu – Founder của Cheer Karaoke Bar, đồng thời là đơn vị nhập khẩu và phân phối bia Đài Loan tại New Zealand.",
        "Ngoài ra còn có cơ hội gặp gỡ Chủ tịch Cộng đồng Người Nhật tại Christchurch, mở ra thêm nhiều góc nhìn về việc xây dựng cộng đồng người châu Á tại New Zealand.",
      ],

      tipsTitle: "Điều chúng tôi học được 💡",

      tips: [
        {
          title: "Giá trị của giáo dục",
          items: [
            "Một doanh nghiệp có thể bắt đầu từ một ý tưởng nhỏ.",
            "Nhưng kiến thức và đào tạo chất lượng sẽ tạo ra giá trị bền vững.",
            "International Culinary Studio là minh chứng cho việc giáo dục trực tuyến hoàn toàn có thể phát triển ra toàn cầu.",
            "Đó cũng là nguồn cảm hứng để tbCareer tiếp tục theo đuổi định hướng giáo dục nghề nghiệp.",
          ],
        },

        {
          title: "Kinh doanh không có biên giới",
          items: [
            "Các founder đến từ Đài Loan, Nhật Bản, New Zealand và nhiều quốc gia khác đều có chung một tinh thần chia sẻ.",
            "Mỗi người kinh doanh ở một lĩnh vực khác nhau nhưng đều hướng đến việc tạo ra giá trị cho cộng đồng.",
            "Networking giúp mở ra nhiều cơ hội hợp tác mà đôi khi không thể tìm thấy trên Internet.",
          ],
        },

        {
          title: "Caljn và hành trình phía trước",
          items: [
            "Chúng tôi mong muốn kết nối với nhiều cộng đồng doanh nghiệp quốc tế hơn.",
            "Tiếp tục phát triển hệ sinh thái Caljn, Odijn và tbCareer.",
            "Đồng thời học hỏi từ những doanh nghiệp đã thành công để mang lại nhiều giá trị hơn cho khách hàng tại New Zealand và quốc tế.",
          ],
        },
      ],

      reflectionTitle: "Khoảnh khắc đặc biệt của buổi tối 💭",

      reflection: [
        "Một trong những khoảnh khắc đáng nhớ nhất của buổi tối là phần trình diễn của nghệ sĩ Andy Lin đến từ New York. Anh không chỉ là nghệ sĩ violin mà còn biểu diễn đàn nhị và đàn hạc AOYAMA (Lever & Pedal Harp), mang đến một không gian âm nhạc giao thoa giữa truyền thống và hiện đại.",
        "Andy Lin đã có nhiều buổi biểu diễn quốc tế tại Mỹ, Australia, châu Âu và New Zealand. Sự góp mặt của một nghệ sĩ đẳng cấp quốc tế đã góp phần nâng tầm sự kiện, đúng với tinh thần 'Business Beyond Borders' – kết nối vượt qua mọi biên giới.",
        "Điều đặc biệt là dù mang đẳng cấp quốc tế, buổi gặp gỡ vẫn giữ được sự gần gũi và ấm áp như một gia đình. Các doanh nhân, founder và khách mời dễ dàng trò chuyện, chia sẻ kinh nghiệm và tạo dựng những mối quan hệ mới.",
        "Âm nhạc đã trở thành cầu nối, giúp xóa nhòa khoảng cách về ngôn ngữ, văn hóa và quốc gia. Đó cũng chính là điều chúng tôi cảm nhận được tại Business Beyond Borders: những cơ hội kinh doanh bền vững thường bắt đầu từ những cuộc gặp gỡ chân thành giữa con người với con người.",
      ],

      closing: [
        "Business Beyond Borders không chỉ giúp Caljn mở rộng mạng lưới kết nối mà còn mang lại nhiều góc nhìn mới về giáo dục, khởi nghiệp và hợp tác quốc tế.",
        "Chúng tôi rất vinh dự được gặp gỡ các founder, doanh nhân và đại diện cộng đồng đến từ nhiều quốc gia khác nhau.",
        "Hy vọng trong tương lai sẽ có thêm nhiều cơ hội để Caljn đồng hành cùng các doanh nghiệp tại New Zealand cũng như trên thị trường quốc tế.",
        "Hành trình xây dựng startup không chỉ là phát triển sản phẩm, mà còn là hành trình xây dựng niềm tin và những mối quan hệ lâu dài.",
        {
          text: "← Quay lại Phần 1",
          to: "/blog/14",
        },
      ],
    },

    en: {
      section: "Blog",

      title:
        "From Ideas to Startups: Building International Connections with Business Beyond Borders (Part 2)",

      intro: [
        "Following our visit to EPIC Christchurch, we attended Business Beyond Borders (BBB), a networking event that brought together founders, entrepreneurs, and business leaders, particularly from the Taiwanese business community in New Zealand.",
        "More than just a networking event, it was an opportunity to learn from established founders while building relationships across Christchurch's diverse international business communities.",
      ],

      highlight:
        "Building a startup isn't only about creating products—it's also about building relationships that create future opportunities.",

      vibeTitle: "People who inspired us 🚀",

      vibe: [
        "We had the pleasure of meeting Dr. Andy Cordier, Founder of International Culinary Studio, an online culinary school that has operated for over 11 years and educated more than 3,000 students through Level 4 and Level 5 programmes.",
        "Inspired by International Culinary Studio, tbCareer International School aspires to become a Level 4–5 vocational education provider in New Zealand, serving as a bridge that helps migrants integrate more quickly into local education, workplace culture, and the job market while building sustainable careers and creating lasting value for their communities.",
        "We also met Sam Lu, Founder of Taizi Baijiu, who is introducing the elegance of Taiwanese baijiu to international markets.",
        "Another inspiring conversation was with Hank Chu, Founder of Cheer Karaoke Bar and an importer and distributor of Taiwanese beer in New Zealand.",
        "We also connected with the President of the Japanese community in Christchurch, gaining valuable insights into building strong multicultural communities across New Zealand.",
      ],

      tipsTitle: "What we learned 💡",

      tips: [
        {
          title: "Education creates long-term value",
          items: [
            "Every successful organisation begins with a simple vision.",
            "High-quality education creates lasting impact beyond commercial success.",
            "International Culinary Studio demonstrates how online vocational education can reach students around the world.",
            "It reinforced tbCareer's long-term educational vision.",
          ],
        },

        {
          title: "Business has no borders",
          items: [
            "Founders from Taiwan, Japan, New Zealand and many other countries shared the same spirit of collaboration.",
            "Although every business operates in a different industry, they all focus on creating value.",
            "Networking often opens doors to opportunities that cannot be found online.",
          ],
        },

        {
          title: "Looking ahead for Caljn",
          items: [
            "We hope to continue building relationships with international business communities.",
            "We'll keep growing the Caljn, Odijn and tbCareer ecosystem.",
            "At the same time, we'll continue learning from successful founders to better serve businesses in New Zealand and beyond.",
          ],
        },
      ],

      reflectionTitle: "A memorable moment ",

      reflection: [
        "One of the most memorable moments of the evening was a performance by New York-based musician Andy Lin. In addition to playing the violin, he also performed on the traditional Chinese erhu and the AOYAMA Lever & Pedal Harp, creating a unique blend of Eastern and Western musical traditions.",
        "Andy Lin has performed internationally across the United States, Australia, Europe and New Zealand. His presence brought an international calibre to the event, perfectly reflecting the spirit of 'Business Beyond Borders'.",
        "What impressed us most was that despite its international standard, the evening remained warm, welcoming and family-like. Founders, business owners and guests connected naturally through genuine conversations and shared experiences.",
        "Music became a bridge that transcended language, culture and geography. It reminded us that the strongest business relationships often begin with authentic human connections—the true meaning of Business Beyond Borders.",
      ],

      closing: [
        "Business Beyond Borders gave Caljn more than valuable business connections—it provided new perspectives on education, entrepreneurship and international collaboration.",
        "We were honoured to meet founders, business owners and community leaders from many different backgrounds.",
        "We look forward to building more partnerships across New Zealand and beyond as our journey continues.",
        "Growing a startup isn't only about developing technology—it's about building trust, community and long-term relationships.",
        {
          text: "👉 Đọc tiếp Phần 2",
          to: "/blog/15",
        },
      ],
    },
  },
  {
    id: 16,

    mainImage: "/blog/blog 16/blog 16.png",

    objectPositionDesktop: "center 0px",
    objectPositionMobile: "center center",

    seoImage: "/blog/blog 16/blog16-1200.jpg",

    images: ["/blog/blog 16/blog 16.png"],

    date: "2026-07-13",

    vi: {
      section: "Blog",

      title:
        "Đừng Đặt Cả Tương Lai Vào Một Công Việc: Hành Trình Xây Nhiều Nguồn Giá Trị",

      intro: [
        "Ở tuổi mà nhiều người nghĩ là 'muộn', mình vẫn bắt đầu học lại từ đầu. Vừa làm full-time, vừa nuôi ba đứa con, vừa âm thầm học những kỹ năng mới và xây từng dự án nhỏ.",
        "Không có tiếng vỗ tay hay sự công nhận ngay lập tức. Chỉ có những ngày kiên trì tích lũy từng chút một để tạo nên một hành trình hoàn toàn mới.",
      ],

      highlight:
        "Trong một thế giới thay đổi quá nhanh, điều an toàn nhất không còn là một công việc ổn định, mà là khả năng tạo ra giá trị từ nhiều hướng khác nhau.",

      vibeTitle: "Một câu hỏi tưởng rất đơn giản 💭",

      vibe: [
        "Mỗi lần gặp lại bạn bè hay quen ai đó mới, câu hỏi đầu tiên thường là: 'Dạo này làm gì?'",
        "Đã có lúc mình thật sự lúng túng vì không biết nên trả lời thế nào.",
        "Không phải vì không có gì để kể, mà vì những gì mình đang làm không còn nằm trong một chức danh duy nhất.",
        "Ngày nay, mình vừa đi làm, vừa phát triển startup, vừa xây cộng đồng, vừa học thêm những lĩnh vực hoàn toàn mới.",
      ],

      tipsTitle: "Điều mình nhận ra 💡",

      tips: [
        {
          title: "Một đường ray không còn đủ",
          items: [
            "AI và công nghệ đang thay đổi gần như mọi ngành nghề.",
            "Không có công việc nào thực sự miễn nhiễm với sự thay đổi.",
            "Phụ thuộc hoàn toàn vào một nguồn thu nhập ngày càng trở nên rủi ro.",
          ],
        },

        {
          title: "Xây sự nghiệp như một bức tranh ghép",
          items: [
            "Giữ công việc chính nếu cần.",
            "Song song đó xây thêm kỹ năng, dự án hoặc thương hiệu cá nhân.",
            "Biến kinh nghiệm cũ thành những cơ hội mới.",
            "Đừng chờ đến khi mất việc mới bắt đầu học điều khác.",
          ],
        },

        {
          title: "Định nghĩa mới về sự giàu có",
          items: [
            "Giàu có không chỉ là mức lương.",
            "Giàu có là khả năng thích nghi.",
            "Là khi một cánh cửa đóng lại, bạn vẫn còn nhiều cánh cửa khác.",
            "Tương lai của bạn không bị quyết định bởi một chiếc ghế hay một công ty duy nhất.",
          ],
        },
      ],

      reflectionTitle: "Điều mình muốn gửi gắm ❤️",

      reflection: [
        "Mình vẫn rất bận. Không việc này thì việc khác. Không phải để chứng minh điều gì với ai, mà để mỗi ngày đều tiến thêm một chút.",
        "Có những điều mình có thể kể ngay. Có những điều vẫn đang âm thầm xây dựng.",
        "Nhưng mình tin rằng đầu tư vào kỹ năng, kiến thức và những mối quan hệ sẽ luôn mang lại lợi nhuận lâu dài hơn bất kỳ chức danh nào.",
        "Thế giới sẽ tiếp tục thay đổi. Điều quan trọng là chúng ta cũng không ngừng thay đổi cùng nó.",
      ],

      closing: [
        "Đừng đặt toàn bộ tương lai vào một chiếc giỏ mang tên 'công việc hiện tại'.",
        "Hãy bắt đầu xây thêm một kỹ năng, một dự án hoặc một nguồn giá trị mới ngay từ hôm nay.",
        "Không cần nhanh hơn người khác. Chỉ cần đều đặn hơn chính mình của ngày hôm qua.",
      ],
    },

    en: {
      section: "Blog",

      title:
        "Don't Put Your Entire Future Into One Job: Building Multiple Sources of Value",

      intro: [
        "At an age many people would call 'too late', I decided to start learning again. Working full-time, raising three children, and quietly building new skills and side projects.",
        "There was no applause or instant recognition—only small, consistent steps that slowly created a completely different future.",
      ],

      highlight:
        "In a rapidly changing world, true security no longer comes from having one stable job—it comes from your ability to create value in multiple ways.",

      vibeTitle: "A simple question that isn't so simple 💭",

      vibe: [
        "Whenever I meet someone, the first question is usually, 'What do you do?'",
        "For a long time, I struggled to answer that question.",
        "Not because I had nothing to say, but because my work no longer fits into a single title.",
        "Today I work full-time, build startups, support communities, and continue learning every day.",
      ],

      tipsTitle: "What I've learned 💡",

      tips: [
        {
          title: "One career path is no longer enough",
          items: [
            "AI and technology are reshaping almost every profession.",
            "No job is completely immune to change.",
            "Depending on a single income source has become increasingly risky.",
          ],
        },

        {
          title: "Build your career like a portfolio",
          items: [
            "Keep your primary job if it serves you.",
            "Develop additional skills and personal projects.",
            "Turn past experience into new opportunities.",
            "Don't wait until change is forced upon you before learning something new.",
          ],
        },

        {
          title: "A new definition of wealth",
          items: [
            "Wealth isn't only measured by salary.",
            "It's measured by adaptability.",
            "It's knowing that if one opportunity disappears, others remain.",
            "Your future shouldn't depend on one employer or one job title.",
          ],
        },
      ],

      reflectionTitle: "My reflection ❤️",

      reflection: [
        "Life is still busy. There is always another project, another lesson, another opportunity to grow.",
        "Not everything needs to be shared immediately. Some things are still quietly being built.",
        "But I truly believe that investing in skills, knowledge and relationships will always deliver greater long-term returns than relying on a single position.",
        "The world will continue to change. Our greatest advantage is our willingness to change with it.",
      ],

      closing: [
        "Don't put your entire future into the basket called 'your current job.'",
        "Start building another skill, another project or another source of value today.",
        "You don't need to move faster than everyone else—you simply need to keep moving.",
      ],
    },
  },

  {
    id: 17,

    mainImage: "/blog/blog 17/wheeloflife.png",

    objectPositionDesktop: "center center",
    objectPositionMobile: "center center",

    seoImage: "/blog/blog 17/wheeloflife.png",

    images: ["/blog/blog 17/wheeloflife.png"],

    date: "2026-08-13",

    vi: {
      section: "Blog",

      title:
        "Wheel of Life – Khi Bạn Cần Nhìn Lại Toàn Bộ Cuộc Sống, Không Chỉ Sự Nghiệp",

      intro: [
        "Có những giai đoạn, chúng ta biết mình không thật sự ổn nhưng lại rất khó trả lời chính xác điều gì đang không ổn. Công việc vẫn có, gia đình vẫn ở đó, mỗi ngày vẫn bận rộn với rất nhiều việc phải làm.",
        "Nhìn từ bên ngoài, mọi thứ dường như vẫn vận hành bình thường. Nhưng bên trong lại có thể xuất hiện một cảm giác khó gọi tên: mệt mỏi, thiếu động lực, mất phương hướng, hoặc đơn giản là cảm thấy cuộc sống hiện tại không còn giống với cuộc sống mình muốn.",
        "Trong những thời điểm như vậy, có lẽ chúng ta chưa cần vội tìm câu trả lời. Điều cần làm trước tiên là dừng lại và nhìn lại bức tranh toàn cảnh.",
      ],

      highlight:
        "Wheel of Life không cho bạn biết phải sống như thế nào. Nó giúp bạn nhìn rõ mình đang ở đâu, điều gì đang quan trọng và mình muốn đi về đâu tiếp theo.",

      vibeTitle: "Wheel of Life là gì? 🎡",

      vibe: [
        "Wheel of Life – Bánh xe cuộc đời – là một công cụ tự đánh giá giúp chúng ta nhìn cuộc sống qua nhiều khía cạnh khác nhau, thay vì chỉ tập trung vào một vấn đề đang khiến mình lo lắng nhất.",
        "Một bánh xe thường bao gồm các lĩnh vực như sự nghiệp, tài chính, sức khỏe, gia đình, các mối quan hệ, phát triển bản thân, giải trí và môi trường sống.",
        "Tuy nhiên, không có một Wheel of Life chuẩn dành cho tất cả mọi người.",
        "Một sinh viên 20 tuổi sẽ có những ưu tiên khác với một người đang nuôi con nhỏ. Một người vừa chuyển đến một quốc gia mới cũng có thể nhìn cuộc sống rất khác với người đã ổn định nhiều năm.",
        "Điều quan trọng là bánh xe đó phải phản ánh cuộc sống và những ưu tiên thực sự của chính bạn.",
      ],

      tipsTitle: "Nhìn lại bánh xe cuộc đời 💭",

      tips: [
        {
          title: "1. Chấm điểm từng lĩnh vực từ 1–10",
          items: [
            "Chọn khoảng 8 lĩnh vực quan trọng nhất trong cuộc sống hiện tại của bạn.",
            "Cho mỗi lĩnh vực một số điểm từ 1 đến 10 dựa trên mức độ hài lòng của bạn.",
            "1 nghĩa là bạn đang rất không hài lòng; 10 nghĩa là bạn cảm thấy rất hài lòng với tình trạng hiện tại.",
            "Đừng suy nghĩ quá lâu. Hãy ghi lại con số đầu tiên phản ánh cảm nhận thật của bạn.",
          ],
        },

        {
          title: "2. Đừng cố tạo ra một bánh xe hoàn hảo",
          items: [
            "Mục tiêu của Wheel of Life không phải là nâng tất cả các lĩnh vực lên 10/10.",
            "Có những giai đoạn sự nghiệp cần được ưu tiên nhiều hơn.",
            "Có lúc gia đình, sức khỏe hoặc việc học tập cần chiếm nhiều thời gian và năng lượng hơn.",
            "Cân bằng không có nghĩa là chia đều thời gian cho mọi thứ.",
            "Cân bằng là hiểu điều gì quan trọng với mình ở thời điểm hiện tại và chủ động lựa chọn cách sử dụng thời gian, năng lượng và sự chú ý.",
          ],
        },

        {
          title: "3. Hỏi điều gì nằm phía sau những con số",
          items: [
            "Nếu sức khỏe là 4/10: Điều gì khiến nó là 4 chứ không phải 7?",
            "Nếu sự nghiệp là 6/10: Điều gì đang thiếu để nó trở thành 7?",
            "Nếu gia đình là 8/10: Điều gì bạn đang làm tốt và muốn tiếp tục duy trì?",
            "Nếu giải trí chỉ là 2/10: Bạn đã bao lâu rồi chưa làm một điều gì chỉ đơn giản vì mình thích?",
            "Giá trị lớn nhất của Wheel of Life không nằm ở điểm số mà nằm ở những câu hỏi xuất hiện sau điểm số đó.",
          ],
        },

        {
          title: "4. Chọn một điểm để bắt đầu",
          items: [
            "Đừng cố thay đổi tám lĩnh vực cùng một lúc.",
            "Hãy chọn một lĩnh vực mà nếu được cải thiện một chút, nó có thể tạo ra tác động tích cực đến nhiều phần khác trong cuộc sống.",
            "Sức khỏe tốt hơn có thể mang lại nhiều năng lượng hơn cho công việc và gia đình.",
            "Tài chính ổn định hơn có thể giúp giảm bớt lo lắng.",
            "Một chút thời gian dành cho bản thân đôi khi cũng đủ để bạn nhìn những vấn đề khác rõ ràng hơn.",
          ],
        },
      ],

      reflectionTitle:
        "Khi vấn đề nghề nghiệp thực ra không chỉ nằm ở nghề nghiệp ❤️",

      reflection: [
        "Trong tư vấn hướng nghiệp, đôi khi một người bắt đầu cuộc trò chuyện bằng câu: 'Tôi muốn đổi nghề.' Nhưng khi đi sâu hơn, câu chuyện có thể hoàn toàn khác.",
        "Có người không ghét công việc. Họ chỉ đang kiệt sức.",
        "Có người không cần đổi nghề. Họ cần một môi trường làm việc phù hợp hơn.",
        "Có người nghĩ mình thiếu động lực, nhưng thực tế đã nhiều năm họ gần như không có thời gian dành cho bản thân.",
        "Có người muốn kiếm nhiều tiền hơn, nhưng điều họ thực sự tìm kiếm lại là cảm giác an toàn.",
        "Và cũng có người nghĩ mình đang thất bại trong sự nghiệp chỉ vì họ đang sử dụng thước đo thành công của người khác để đánh giá cuộc sống của chính mình.",
        "Đó là lý do tôi luôn muốn nhìn sự nghiệp như một phần của một bức tranh lớn hơn. Nghề nghiệp liên quan đến sức khỏe, tài chính, gia đình, giá trị sống, môi trường, các mối quan hệ và cả phiên bản con người mà chúng ta muốn trở thành.",
      ],

      closing: [
        "Nếu hôm nay bạn có 15 phút, hãy lấy một tờ giấy, vẽ một vòng tròn và chia nó thành tám phần.",
        "Viết tám lĩnh vực quan trọng nhất trong cuộc sống của bạn và chấm điểm từng lĩnh vực từ 1–10.",
        "Sau đó hãy tự hỏi: Điều gì trong cuộc sống hiện tại tôi thực sự hài lòng? Lĩnh vực nào đang lấy nhiều năng lượng của tôi nhất? Nếu chỉ cải thiện một điều trong ba tháng tới, tôi muốn đó là điều gì?",
        "Cuối cùng, hãy viết xuống một hành động nhỏ mà bạn có thể thực hiện ngay trong tuần này.",
        "Bạn không cần thay đổi toàn bộ cuộc đời để bắt đầu cảm thấy cuộc sống đang thay đổi.",
        "Bởi vì trong hướng nghiệp, câu hỏi không chỉ là: 'Bạn muốn làm nghề gì?'",
        "Một câu hỏi lớn hơn có lẽ đáng để chúng ta dành thời gian suy nghĩ là: 'Bạn muốn xây dựng một cuộc sống như thế nào – và sự nghiệp sẽ đóng vai trò gì trong cuộc sống đó?'",
      ],
    },

    en: {
      section: "Blog",

      title:
        "Wheel of Life – When You Need to Look at Your Whole Life, Not Just Your Career",

      intro: [
        "There are times when we know something does not feel quite right, yet it can be surprisingly difficult to explain exactly what is wrong. We still have a job, our family is still there, and every day remains filled with things that need to be done.",
        "From the outside, life may appear to be functioning normally. Inside, however, we may feel tired, unmotivated, directionless, or simply aware that the life we are living no longer feels like the life we want.",
        "At moments like these, we may not need to rush into finding an answer. Sometimes the first step is simply to pause and look at the bigger picture.",
      ],

      highlight:
        "The Wheel of Life does not tell you how to live. It helps you see where you are, what matters to you now, and where you may want to go next.",

      vibeTitle: "What is the Wheel of Life? 🎡",

      vibe: [
        "The Wheel of Life is a simple self-reflection tool that helps us look at several areas of life rather than focusing only on the one problem that currently feels most urgent.",
        "A typical wheel might include career, finances, health, family, relationships, personal growth, fun and recreation, and physical environment.",
        "But there is no single Wheel of Life that works for everyone.",
        "A university student may have very different priorities from a parent raising young children. Someone who has recently moved to another country may also evaluate life very differently from someone who has been settled for many years.",
        "Your wheel should reflect your life, your circumstances and what genuinely matters to you right now.",
      ],

      tipsTitle: "Taking a closer look at your life 💭",

      tips: [
        {
          title: "1. Rate each area from 1–10",
          items: [
            "Choose around eight areas that matter most in your life right now.",
            "Give each area a score from 1 to 10 based on your current level of satisfaction.",
            "A score of 1 means you are deeply dissatisfied, while 10 means you feel highly satisfied with that area of your life.",
            "Try not to overthink your answers. Your first instinct can often tell you something important.",
          ],
        },

        {
          title: "2. Don't try to create a perfect wheel",
          items: [
            "The goal is not to make every area of your life a 10 out of 10.",
            "There may be seasons when your career requires more attention.",
            "At other times, family, health, study or personal development may need to become the priority.",
            "Balance does not mean giving equal time to everything.",
            "Balance means understanding what matters most in your current season of life and making conscious choices about where you place your time, energy and attention.",
          ],
        },

        {
          title: "3. Explore the questions behind the numbers",
          items: [
            "If your health is 4/10, ask: What makes it a 4 rather than a 7?",
            "If your career is 6/10, ask: What would need to change for it to become a 7?",
            "If family is 8/10, ask: What am I doing well that I want to continue?",
            "If fun and recreation is 2/10, ask: When was the last time I did something simply because I enjoyed it?",
            "The real value of the Wheel of Life is not the score itself. It is the conversation and reflection that the score creates.",
          ],
        },

        {
          title: "4. Choose one place to begin",
          items: [
            "Do not try to fix all eight areas at the same time.",
            "Choose one area where a small improvement could positively influence several other parts of your life.",
            "Improving your health may give you more energy for work and family.",
            "Greater financial stability may reduce stress and create more choices.",
            "Creating even a little more time for yourself may help you see other challenges more clearly.",
          ],
        },
      ],

      reflectionTitle:
        "When a career problem isn't really only about your career ❤️",

      reflection: [
        "In career conversations, someone may begin by saying, 'I want to change careers.' But once we explore the situation more deeply, the real story can be quite different.",
        "Some people do not hate their jobs. They are exhausted.",
        "Some do not need a new career. They need a healthier working environment.",
        "Some believe they have lost motivation, when in reality they have spent years giving themselves almost no time to rest or reconnect with who they are.",
        "Some say they want to earn more money, when what they are really searching for is a greater sense of security.",
        "Others feel unsuccessful simply because they are measuring their lives against someone else's definition of success.",
        "This is why I prefer to see career as one part of a much bigger picture. Our work is connected to our health, finances, family, relationships, values, environment and the person we hope to become.",
      ],

      closing: [
        "If you have 15 minutes today, take a piece of paper, draw a circle and divide it into eight sections.",
        "Write down eight areas that matter most in your life and give each one a score from 1 to 10.",
        "Then ask yourself: What am I genuinely happy with right now? Which area is taking the most energy from me? If I could improve just one thing over the next three months, what would I choose?",
        "Finally, write down one small action you can take this week.",
        "You do not need to change your entire life before you can begin to feel that your life is changing.",
        "Because career development is not only about answering the question: 'What job do you want to do?'",
        "Perhaps the bigger question is: 'What kind of life do you want to build – and what role do you want your career to play within that life?'",
      ],
    },
  },
];
